import * as THREE from "three";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, Environment, useGLTF } from "@react-three/drei";
import React, { useMemo, useState, useEffect, Suspense, useRef } from "react";
import { useNavigate } from "react-router-dom";

import Stripes2 from "../../images/goal1.png";
import Stripes3 from "../../images/goal2.png";

// -------------------- kit design --------------------
import kit1 from "../../images/kits/23.png";
import kit2 from "../../images/kits/afdffe.png";
import kit3 from "../../images/kits/dadfdf.png";
import kit4 from "../../images/kits/dfadfd.png";

// -------------------- Local pattern thumbs --------------------
import design1 from "../../images/1st design.png";
import design2 from "../../images/4th design.png";
import design3 from "../../images/5rd Design.png";
import design4 from "../../images/9rd Design.png";
import design5 from "../../images/13rd Design.png";
import design6 from "../../images/png-01p.png";
import design7 from "../../images/proved_pattern/png-01 (2).png";

// -------------------- Sample preset logos --------------------
import logo1 from "../../images/p-logo1.png";

// -------------------- Sample preset variations --------------------
import variation1 from "../../images/images/variation1.jpeg";
import variation2 from "../../images/images/image (3).png";
import variation3 from "../../images/images/White Round Neck T Shirt Mockup Plain Round Neck – Next Print (1).png";

// -------------------- Sample preset variations --------------------
import variation4 from "../../images/images/Round Neck.jpg";
import variation5 from "../../images/images/V Neck.jpg";
import variation6 from "../../images/images/Polo Collar neck (1).jpg";

import { Link } from "react-router-dom";

// -------------------- Sample designs --------------------
const ONLINE_DESIGNS = [
  {
    id: 3,
    name: "Brush A",
    img: Stripes3,
    path: "/goalkeeper-2",
  },
  {
    id: 2,
    name: "Diagonal A",
    img: Stripes2,
    path: "/goalkeeper",
  },

];

const NECK_STYLES = [
  { id: "crew", name: "Crew Neck", img: variation3, path: "/colar" },
  { id: "v", name: "V-Neck", img: variation1, path: "/vnack" },
  { id: "polo", name: "Polo Collar", img: variation2, path: "/polo" },
];

// -------------------- Full Sleeves Styles --------------------
const FULL_SLEEVES_STYLES = [
  { 
    id: "full-sleeve-1", 
    name: "Long Sleeve", 
    img: variation4, 
    path: "/colar-full" 
  },
  { 
    id: "full-sleeve-2", 
    name: "Compression Sleeve", 
    img: variation5, 
    path: "/vnack-full" 
  },
  { 
    id: "full-sleeve-3", 
    name: "Raglan Sleeve", 
    img: variation6, 
    path: "/polo-full" 
  },
];

function NeckStylesList({ onNeckStyleSelect }) {
  return (
    <div className="neck-styles">
      {NECK_STYLES.map((neck) => (
        <Link 
          key={neck.id} 
          to={neck.path}
          onClick={() => onNeckStyleSelect && onNeckStyleSelect(neck)}
        >
          <img src={neck.img} alt={neck.name} />
          <p>{neck.name}</p>
        </Link>
      ))}
    </div>
  );
}

// New: Kit Names tab (4 online images)
const KIT_NAMES = [
  {
    id: "home",
    name: "soccer Kit",
    img: kit1,
  },
  {
    id: "away",
    name: "Basket Kit",
    img: kit2,
  },
  {
    id: "third",
    name: "cricket Kit",
    img: kit3,
  },
  {
    id: "gk",
    name: "Goalkeeper Kit",
    img: kit4,
  },
];

// -------------------- Patterns --------------------
const PATTERNS = [
  { id: 1, name: "Zig Zag", img: design1 },
  { id: 2, name: "Polka Dots", img: design2 },
  { id: 3, name: "Geometric", img: design3 },
  { id: 4, name: "Camouflage", img: design3 },
  { id: 5, name: "Floral", img: design4 },
  { id: 6, name: "Stripes", img: design5 },
  { id: 7, name: "Upper Design", img: design6 },
   { id: 8, name: "Lion Design", img: design7 },
];

// -------------------- Preset Logos --------------------
const PRESET_LOGOS = [{ id: "preset-1", name: "Swoosh", img: logo1 }];

// -------------------- Fonts --------------------
const FONT_URL =
  "https://fonts.googleapis.com/css2?family=Russo+One&family=Roboto+Condensed:wght@400;700&display=swap";
const FONT_FAMILY = "'Russo One', 'Roboto Condensed', sans-serif";

// -------------------- Logo default spawns --------------------
const DEFAULT_FRONT_POS_1 = { x: 0.35, y: 0.2, scale: 0.12, rot: 0, opacity: 1, blend: "normal" };
const DEFAULT_FRONT_POS_2 = { x: 0.2, y: 0.2, scale: 0.12, rot: 0, opacity: 1, blend: "normal" };
const DEFAULT_BACK_POS = { x: 0.7, y: 0.9, scale: 0.22, rot: 0, opacity: 1, blend: "normal" };

// Shorts (front) default left/right
const DEFAULT_SHORTS_LEFT_FRONT = {
  x: 0.2,
  y: 0.35,
  scale: 0.3,
  rot: 0,
  opacity: 1,
  blend: "normal",
  side: "left",
};
const DEFAULT_SHORTS_RIGHT_FRONT = {
  x: 0.75,
  y: 0.35,
  scale: 0.3,
  rot: 0,
  opacity: 1,
  blend: "normal",
  side: "right",
};

// Shorts (back) single centered default (NO left/right for back)
const DEFAULT_SHORTS_BACK_CENTER = {
  x: 0.5,
  y: 0.3,
  scale: 0.5,
  rot: 0,
  opacity: 1,
  blend: "normal",
  side: "center",
};

// Shoulder logo defaults - FIXED POSITIONS
const DEFAULT_L_SHOULDER_F = { x: 0.08, y: 0.11, scale: 0.08, rot: 1, opacity: 1, blend: "normal" };
const DEFAULT_R_SHOULDER_F = { x:0.48, y:0.13, scale: 0.08, rot: -1, opacity: 1, blend: "normal" };

// Back shoulder logo defaults
const DEFAULT_L_SHOULDER_B = { x: 0.08, y: 0.11, scale: 0.08, rot: 1, opacity: 1, blend: "normal" };
const DEFAULT_R_SHOULDER_B = { x:0.48, y:0.13, scale: 0.08, rot: -1, opacity: 1, blend: "normal" };

// -------------------- REMOVED ALL BOUNDS FOR INFINITE MOVEMENT --------------------
const INFINITE_BOUNDS = { xMin: -Infinity, xMax: Infinity, yMin: -Infinity, yMax: Infinity };

// -------------------- helpers --------------------
function setUniformColor(uniform, colorTHREE) {
  if (!uniform) return;
  const v = uniform.value;
  if (v?.isColor) v.copy(colorTHREE);
  else if (v?.isVector3) v.set(colorTHREE.r, colorTHREE.g, colorTHREE.b);
  else uniform.value = colorTHREE.clone();
}

function setUniformVec2(uniform, vec2THREE) {
  if (!uniform) return;
  const v = uniform.value;
  if (v?.isVector2) v.copy(vec2THREE);
  else if (Array.isArray(v) && v.length >= 2) {
    v[0] = vec2THREE.x;
    v[1] = vec2THREE.y;
  } else uniform.value = vec2THREE.clone();
}
function setUniformFloat(uniform, n) {
  if (uniform) uniform.value = Number(n);
}
function setUniformVec3(uniform, v3) {
  if (uniform) (uniform.value?.isVector3 ? uniform.value.copy(v3) : (uniform.value = v3.clone()));
}
function clamp(n, min, max) {
  return Math.min(max, Math.max(min, n));
}

function applyGradStopsToShader(shader, stops) {
  if (!shader?.uniforms) return;
  const MAX = 8;
  const count = Math.min(MAX, stops?.length || 0);

  // Ensure uGradColors is always an array of THREE.Color
  if (!shader.uniforms.uGradColors?.value) {
    shader.uniforms.uGradColors = {
      value: Array.from({ length: MAX }, () => new THREE.Color(1, 1, 1)),
    };
  } else {
    // Convert existing values to THREE.Color if they aren't already
    shader.uniforms.uGradColors.value = shader.uniforms.uGradColors.value.map(
      (c) => (c instanceof THREE.Color ? c : new THREE.Color(c || 0xffffff))
    );
  }

  if (!shader.uniforms.uGradPos?.value)
    shader.uniforms.uGradPos = { value: new Float32Array(MAX).fill(0) };

  if (shader.uniforms.uGradCount) shader.uniforms.uGradCount.value = count;

  for (let i = 0; i < MAX; i++) {
    const s = i < count ? stops[i] : null;
    const col = new THREE.Color(s?.color || "#ffffff");
    const pos =
      s && typeof s.pos === "number"
        ? s.pos
        : i < count
        ? i / Math.max(1, count - 1)
        : 1;

    // Safely copy color
    shader.uniforms.uGradColors.value[i].copy(col);
    shader.uniforms.uGradPos.value[i] = pos;
  }
}

// -------------------- Load Google Font --------------------
function useLoadGoogleFont(href) {
  useEffect(() => {
    if (!href) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
    if (document.fonts?.load) document.fonts.load(`10pt ${FONT_FAMILY}`);
    return () => document.head.removeChild(link);
  }, [href]);
}

// -------------------- TEXT CANVAS TEXTURE --------------------
function useTextTexture(
  text,
  {
    font = FONT_FAMILY,
    fontSize = 40,
    fill = "#fff",
    stroke = "#000",
    strokeWidth = 4,
    paddingX = 32,
    paddingY = 16,
    textAlign = "center",
    baseline = "middle",
    bg = "transparent",
    isBold = true,
    letterSpacing = 0,
  } = {}
) {
  return useMemo(() => {
    if (text === null || text === undefined || text === "") return null;
    const safeStrokeW = clamp(Number(strokeWidth) || 0, 0, 6);
    const scale = 1;

    const meas = document.createElement("canvas").getContext("2d");
    meas.font = `${isBold ? "bold " : ""}${fontSize * scale}px ${font}`;
    const chars = String(text).split("");
    let totalW = 0;
    const widths = chars.map((ch) => {
      const w = meas.measureText(ch).width;
      totalW += w;
      return w;
    });
    if (chars.length > 1) totalW += (chars.length - 1) * letterSpacing;

    const canvas = document.createElement("canvas");
    const W = Math.ceil(totalW) + paddingX * 2;
    const H = Math.ceil(fontSize * scale) + paddingY * 2;
    canvas.width = Math.max(2, W);
    canvas.height = Math.max(2, H);
    const ctx = canvas.getContext("2d");

    if (bg !== "transparent") {
      ctx.fillStyle = bg;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    ctx.font = `${isBold ? "bold " : ""}${fontSize * scale}px ${font}`;
    ctx.textAlign = textAlign;
    ctx.textBaseline = baseline;

    let startX = canvas.width / 2 - totalW / 2;
    const cy = canvas.height / 2;

    ctx.lineJoin = "round";
    ctx.lineCap = "round";
    for (let i = 0; i < chars.length; i++) {
      const ch = chars[i];
      if (safeStrokeW > 0) {
        ctx.lineWidth = safeStrokeW * scale;
        ctx.strokeStyle = stroke;
        ctx.strokeText(ch, startX + widths[i] / 2, cy);
      }
      ctx.fillStyle = fill;
      ctx.fillText(ch, startX + widths[i] / 2, cy);
      startX += widths[i] + (i < chars.length - 1 ? letterSpacing : 0);
    }

    const texture = new THREE.CanvasTexture(canvas);
    texture.colorSpace = THREE.SRGBColorSpace;
    texture.anisotropy = 4;
    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.generateMipmaps = false;
    texture.wrapS = THREE.ClampToEdgeWrapping;
    texture.wrapT = THREE.ClampToEdgeWrapping;
    texture.flipY = false;
    texture.needsUpdate = true;
    return texture;
  }, [
    text,
    font,
    fontSize,
    fill,
    stroke,
    strokeWidth,
    paddingX,
    paddingY,
    textAlign,
    baseline,
    bg,
    isBold,
    letterSpacing,
  ]);
}

// -------------------- Optional texture loader --------------------
function useOptionalTexture(url, { repeat = false, flipY = true } = {}) {
  const [tex, setTex] = useState(null);
  useEffect(() => {
    if (!url) {
      setTex(null);
      return;
    }
    let alive = true;
    const loader = new THREE.TextureLoader();
    loader.setCrossOrigin("anonymous");
    loader.load(
      url,
      (t) => {
        if (!alive) return;
        t.colorSpace = THREE.SRGBColorSpace;
        t.anisotropy = 4;
        t.minFilter = THREE.LinearFilter;
        t.magFilter = THREE.LinearFilter;
        t.generateMipmaps = false;
        t.flipY = flipY;
        // Always use ClampToEdgeWrapping to prevent repeating
        t.wrapS = THREE.ClampToEdgeWrapping;
        t.wrapT = THREE.ClampToEdgeWrapping;
        t.needsUpdate = true;
        setTex(t);
      },
      undefined,
      () => setTex(null)
    );
    return () => {
      alive = false;
    };
  }, [url, repeat, flipY]);
  return tex;
}

// -------------------- Composite texture builder --------------------
function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

/** layers: [{ id, name, src, enabled, x, y, scale, rot, opacity, blend, part, side? }] */
function useLogosCompositeTexture(layers, size = 1024) {
  const [tex, setTex] = useState(null);
  useEffect(() => {
    let disposed = false;
    (async function build() {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, size, size);

        for (const L of layers.filter((l) => l.enabled && l.src)) {
          let img;
          try {
            img = await loadImage(L.src);
          } catch {
            continue;
          }

          const pxW = Math.max(0.005, L.scale) * size;
          const cx = L.x * size;
          const cy = L.y * size;

          ctx.save();
          ctx.globalCompositeOperation = L.blend || "source-over";
          ctx.globalAlpha = Math.max(0, Math.min(1, L.opacity ?? 1));
          ctx.translate(cx, cy);
          ctx.rotate(L.rot || 0);
          ctx.drawImage(img, -pxW / 2, -pxW / 2, pxW, pxW);
          ctx.restore();
        }

        const t = new THREE.CanvasTexture(canvas);
        t.colorSpace = THREE.SRGBColorSpace;
        t.anisotropy = 4;
        t.minFilter = THREE.LinearFilter;
        t.magFilter = THREE.LinearFilter;
        t.generateMipmaps = false;
        t.wrapS = THREE.ClampToEdgeWrapping;
        t.wrapT = THREE.ClampToEdgeWrapping;
        t.flipY = false;
        t.needsUpdate = true;
        if (!disposed) setTex(t);
      } catch {
        if (!disposed) setTex(null);
      }
    })();
    return () => {
      disposed = true;
    };
  }, [JSON.stringify(layers), size]);
  return tex;
}

// -------------------- UTIL --------------------
const makeStop = (color, pos) => ({
  id:
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2),
  color,
  pos,
});

// -------------------- Mesh name → part key --------------------
const NAME_TO_KEY = {
  // Shirt
  "F Shirt": "front",
  "B Shirt": "back",

  // Shorts
  "F Short": "shortsFront",
  "B Short": "shortsBack",

  // Shoulder Front
  "L Shoulder F": "lShoulderF",
  "R Shoulder F": "rShoulderF",

  // Shoulder Back
  "L Shoulder B": "lShoulderB",
  "R Shoulder B": "rShoulderB",

  // Arm Stripes
  "L Stripe": "lArmStripe",
  "R Stripe": "rArmStripe",

  // Bottom Stripes (unique to goalkeeper)
  "L Bottom Stripe": "lBottomStripe",
  "R Bottom Stripe": "rBottomStripe",

  // Collar
  "Round Neck Collar": "neck",

  // 🧤 Gloves (NEW)
  "Gloves": "gloves",
  "Left Glove": "gloves",
  "Right Glove": "gloves",
  "GK Gloves": "gloves",
  "Hand L": "gloves",
  "Hand R": "gloves",

  // Safe aliases
  "Front": "front",
  "Back": "back",
  "Collar": "neck",
  "Neck": "neck",
  "Short": "shortsFront",
  "Shorts": "shortsFront"
};


function partKeyFromName(name = "") {
  if (NAME_TO_KEY[name]) return NAME_TO_KEY[name];
  const raw = String(name)
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
  const has = (s) => raw.includes(s);
  
  // Enhanced shoulder detection - FIXED FOR FRONT SHOULDERS
  if ((has("shoulderl") || has("lshoulder") || has("leftshoulder") || 
       has("shoulder_l") || has("l_shoulder") || has("left_shoulder")) && 
      !has("back")) return "lShoulderF";
  
  if ((has("shoulderr") || has("rshoulder") || has("rightshoulder") ||
       has("shoulder_r") || has("r_shoulder") || has("right_shoulder")) && 
      !has("back")) return "rShoulderF";
  
  // Back shoulders
  if ((has("shoulderl") || has("lshoulder") || has("leftshoulder") ||
       has("shoulder_l") || has("l_shoulder") || has("left_shoulder")) && 
      has("back")) return "lShoulderB";
  
  if ((has("shoulderr") || has("rshoulder") || has("rightshoulder") ||
       has("shoulder_r") || has("r_shoulder") || has("right_shoulder")) && 
      has("back")) return "rShoulderB";
  
  if (has("frontshirt") || has("fshirt") || has("frontbody") || has("front") || has("chest"))
    return "front";
  if (has("backshirt") || has("bshirt") || has("backbody") || has("back")) return "back";
  if (has("stripel") || has("lstripe")) return "lArmStripe";
  if (has("striper") || has("rstripe")) return "rArmStripe";
  if (has("sleevel") || has("lsleeve") || has("leftsleeve") || has("leftarm")) return "lSleeve";
  if (has("sleever") || has("rsleeve") || has("rightsleeve") || has("rightarm")) return "rSleeve";
  if (has("neck") || has("collar") || has("ribcollar")) return "neck";
  if (has("fshort") || has("frontshort")) return "shortsFront";
  if (has("bshort") || has("backshort")) return "shortsBack";
  if (has("short") || has("pant") || has("trouser") || has("bottom")) return "shortsFront";
  if (has("shirt") || has("torso") || has("body")) return "front";

  // 🧤 Gloves (NEW)
  if (
    has("glove") ||
    has("hand") ||
    has("gkglove") ||
    has("goalkeeperglove")
  )
    return "gloves";

  return "other";
}


// --------------------------------------------------------------
//                       FULL SLEEVES SOCCER KIT MODEL
// --------------------------------------------------------------
function FullSleevesSoccerKitModel({
  baseColor = "#ffffff",
  useBaseGrad,
  gradStops,
  gradAngle,
  patternUrl,
  showPattern,
  patternColor,
  patternStrength = 0.7,
  isUploadedPattern = false,

  // Front Pattern transformation controls
  patternPosition = { x: 0, y: 0 },
  patternScale = 1,
  patternRotation = 0,
  showPatternOnFront = true,

  // Back Pattern transformation controls
  backPatternUrl,
  showBackPattern,
  backPatternColor,
  backPatternStrength = 0.7,
  isUploadedBackPattern = false,
  backPatternPosition = { x: 0, y: 0 },
  backPatternScale = 1,
  backPatternRotation = 0,
  showPatternOnBack = true,

  overlayFrontTex,
  overlayBackTex,
  overlayShortsFrontTex,
  overlayShortsBackTex,
  overlayLShoulderFTex,
  overlayRShoulderFTex,

  // Front Text 1
  textContent,
  showText,
  textColor,
  textStroke,
  textStrokeW,
  textPosition = [0.28, 0.3],
  textScale = [0.2, 0.2],
  textFontSize = 90,
  textLetterSpacing = 0,

  // Front Text 2 (⚠ shader se hata diya texture limit ki wajah se)
  textContent2,
  showText2,
  textColor2,
  textStroke2,
  textStrokeW2,
  textPosition2 = [0.28, 0.5],
  textScale2 = [0.2, 0.2],
  textFontSize2 = 90,
  textLetterSpacing2 = 0,

  // Back Name 1
  backTextContent,
  showBackText,
  backTextColor,
  backTextStroke,
  backTextStrokeW,
  backTextPosition = [0.7, 0.62],
  backTextScale = [0.2, 0.2],
  backTextFontSize = 90,
  backTextLetterSpacing = 0,

  // Back Name 2 (⚠ shader se hata diya texture limit ki wajah se)
  backTextContent2,
  showBackText2,
  backTextColor2,
  backTextStroke2,
  backTextStrokeW2,
  backTextPosition2 = [0.7, 0.75],
  backTextScale2 = [0.2, 0.2],
  backTextFontSize2 = 90,
  backTextLetterSpacing2 = 0,

  // Front Number
  frontNumberValue,
  showFrontNumber,
  frontNumberColor,
  frontNumberStroke,
  frontNumberStrokeW,
  frontNumberPosition = [0.45, 0.45],
  frontNumberScale = [0.28, 0.28],
  frontNumberFontSize = 140,
  frontNumberLetterSpacing = 0,

  // Back Number
  backNumberValue,
  showBackNumber,
  backNumberColor,
  backNumberStroke,
  backNumberStrokeW,
  backNumberPosition = [0.73, 0.8],
  backNumberScale = [0.25, 0.25],
  backNumberFontSize = 160,
  backNumberLetterSpacing = 0,

  // Shorts Front Number
  shortsFrontNumberValue,
  showShortsFrontNumber,
  shortsFrontNumberColor,
  shortsFrontNumberStroke,
  shortsFrontNumberStrokeW,
  shortsFrontNumberPosition = [0.3, 0.4],
  shortsFrontNumberScale = [0.25, 0.25],
  shortsFrontNumberFontSize = 80,
  shortsFrontNumberLetterSpacing = 0,

  // Shorts Back Number
  shortsBackNumberValue,
  showShortsBackNumber,
  shortsBackNumberColor,
  shortsBackNumberStroke,
  shortsBackNumberStrokeW,
  shortsBackNumberPosition = [0.5, 0.3],
  shortsBackNumberScale = [0.35, 0.35],
  shortsBackNumberFontSize = 100,
  shortsBackNumberLetterSpacing = 0,

  tintFront,
  tintBack,
  tintLArmStripe,
  tintRArmStripe,
  tintLShoulderF,
  tintRShoulderF,
  tintNeck,
  tintLSleeve,
  tintRSleeve,
  tintShortsFront,
  tintShortsBack,
}) {
  const { scene } = useGLTF("/assets/images/Round_Neck_Goal_Keeper_Kit.glb");
  useLoadGoogleFont(FONT_URL);
  scene.position.y = -2.50;

  // just to avoid eslint unused warnings (but NOT used in shader)
  void overlayLShoulderFTex;
  void overlayRShoulderFTex;
  void textContent2;
  void showText2;
  void backTextContent2;
  void showBackText2;

  const [bboxMin, setBboxMin] = useState(new THREE.Vector3(-0.5, -0.5, -0.5));
  const [bboxMax, setBboxMax] = useState(new THREE.Vector3(0.5, 0.5, 0.5));

  useEffect(() => {
    if (!scene) return;
    scene.updateMatrixWorld(true);
    const box = new THREE.Box3().setFromObject(scene);
    if (!box.isEmpty()) {
      setBboxMin(box.min.clone());
      setBboxMax(box.max.clone());
    }
  }, [scene]);

  useEffect(() => {
    if (!scene) return;
    scene.traverse((c) => {
      if (c.isMesh) {
        c.geometry?.computeBoundingBox?.();
        const mats = Array.isArray(c.material) ? c.material : [c.material];
        mats.forEach((m) => {
          if (m?.isMaterial) m.precision = "mediump";
        });
      }
    });
  }, [scene]);

  // Pattern texture loading - NO REPEAT
  const patternTex = useOptionalTexture(showPattern ? patternUrl : null, {
    repeat: false,
    flipY: true,
  });

  // Back Pattern texture loading
  const backPatternTex = useOptionalTexture(showBackPattern ? backPatternUrl : null, {
    repeat: false,
    flipY: true,
  });

  // Textures for all text elements
  const textTex = useTextTexture(textContent, {
    font: FONT_FAMILY,
    fontSize: textFontSize,
    fill: textColor,
    stroke: textStroke,
    strokeWidth: textStrokeW,
    isBold: true,
    letterSpacing: textLetterSpacing,
  });

  const textTex2 = useTextTexture(textContent2, {
    font: FONT_FAMILY,
    fontSize: textFontSize2,
    fill: textColor2,
    stroke: textStroke2,
    strokeWidth: textStrokeW2,
    isBold: true,
    letterSpacing: textLetterSpacing2,
  });

  const backTextTex = useTextTexture(backTextContent, {
    font: FONT_FAMILY,
    fontSize: backTextFontSize,
    fill: backTextColor,
    stroke: backTextStroke,
    strokeWidth: backTextStrokeW,
    isBold: true,
    letterSpacing: backTextLetterSpacing,
  });

  const backTextTex2 = useTextTexture(backTextContent2, {
    font: FONT_FAMILY,
    fontSize: backTextFontSize2,
    fill: backTextColor2,
    stroke: backTextStroke2,
    strokeWidth: backTextStrokeW2,
    isBold: true,
    letterSpacing: backTextLetterSpacing2,
  });

  const frontNumTex = useTextTexture(frontNumberValue, {
    font: FONT_FAMILY,
    fontSize: frontNumberFontSize,
    fill: frontNumberColor,
    stroke: frontNumberStroke,
    strokeWidth: frontNumberStrokeW,
    isBold: true,
    letterSpacing: frontNumberLetterSpacing,
  });

  const backNumTex = useTextTexture(backNumberValue, {
    font: FONT_FAMILY,
    fontSize: backNumberFontSize,
    fill: backNumberColor,
    stroke: backNumberStroke,
    strokeWidth: backNumberStrokeW,
    isBold: true,
    letterSpacing: backNumberLetterSpacing,
  });

  const shortsFrontNumTex = useTextTexture(shortsFrontNumberValue, {
    font: FONT_FAMILY,
    fontSize: shortsFrontNumberFontSize,
    fill: shortsFrontNumberColor,
    stroke: shortsFrontNumberStroke,
    strokeWidth: shortsFrontNumberStrokeW,
    isBold: true,
    letterSpacing: shortsFrontNumberLetterSpacing,
  });

  const shortsBackNumTex = useTextTexture(shortsBackNumberValue, {
    font: FONT_FAMILY,
    fontSize: shortsBackNumberFontSize,
    fill: shortsBackNumberColor,
    stroke: shortsBackNumberStroke,
    strokeWidth: shortsBackNumberStrokeW,
    isBold: true,
    letterSpacing: shortsBackNumberLetterSpacing,
  });

  // Clone materials into MeshStandard
  useEffect(() => {
    if (!scene) return;
    scene.traverse((o) => {
      if (!o.isMesh || !o.material) return;
      if (Array.isArray(o.material)) {
        o.material = o.material.map((m) => {
          const std =
            m instanceof THREE.MeshStandardMaterial
              ? m
              : new THREE.MeshStandardMaterial().copy(m);
          return std.clone();
        });
      } else {
        const m = o.material;
        const std =
          m instanceof THREE.MeshStandardMaterial
            ? m
            : new THREE.MeshStandardMaterial().copy(m);
        o.material = std.clone();
      }
    });
  }, [scene]);

  // Install custom shader
  useEffect(() => {
    if (!scene) return;
    const base = new THREE.Color(baseColor);
    const pCol = new THREE.Color(patternColor);
    const backPCol = new THREE.Color(backPatternColor);

    // Pattern transformation uniforms
    const patternPos = new THREE.Vector2(patternPosition.x, patternPosition.y);
    const patternScl = new THREE.Vector2(patternScale, patternScale);

    // Back Pattern transformation uniforms
    const backPatternPos = new THREE.Vector2(backPatternPosition.x, backPatternPosition.y);
    const backPatternScl = new THREE.Vector2(backPatternScale, backPatternScale);

    // Text positions and scales
    const tPos = new THREE.Vector2(...textPosition);
    const tScl = new THREE.Vector2(...textScale);
    const tPos2 = new THREE.Vector2(...textPosition2);
    const tScl2 = new THREE.Vector2(...textScale2);
    const btPos = new THREE.Vector2(...backTextPosition);
    const btScl = new THREE.Vector2(...backTextScale);
    const btPos2 = new THREE.Vector2(...backTextPosition2);
    const btScl2 = new THREE.Vector2(...backTextScale2);
    const fnPos = new THREE.Vector2(...frontNumberPosition);
    const fnScl = new THREE.Vector2(...frontNumberScale);
    const bnPos = new THREE.Vector2(...backNumberPosition);
    const bnScl = new THREE.Vector2(...backNumberScale);
    const sfnPos = new THREE.Vector2(...shortsFrontNumberPosition);
    const sfnScl = new THREE.Vector2(...shortsFrontNumberScale);
    const sbnPos = new THREE.Vector2(...shortsBackNumberPosition);
    const sbnScl = new THREE.Vector2(...shortsBackNumberScale);

    scene.traverse((obj) => {
      if (!obj.isMesh) return;
      const key = partKeyFromName(obj.name);
      const isFront = key === "front" ? 1.0 : 0.0;
      const isBack = key === "back" ? 1.0 : 0.0;
      const isShortsFront = key === "shortsFront" ? 1.0 : 0.0;
      const isShortsBack = key === "shortsBack" ? 1.0 : 0.0;
      const isLShoulderF = key === "lShoulderF" ? 1.0 : 0.0;
      const isRShoulderF = key === "rShoulderF" ? 1.0 : 0.0;

      const mats = Array.isArray(obj.material) ? obj.material : [obj.material];
      mats.forEach((mat, idx) => {
        if (!mat) return;
        if (!(mat instanceof THREE.MeshStandardMaterial)) {
          const std = new THREE.MeshStandardMaterial();
          std.copy(mat);
          if (Array.isArray(obj.material)) obj.material[idx] = std;
          else obj.material = std;
          mat = std;
        }
        mat.color.copy(base);
        mat.map = null;
        mat.defines = { ...(mat.defines || {}), USE_UV: "" };

        const pickTint = () => {
          switch (key) {
            case "front":
              return new THREE.Color(tintFront);
            case "back":
              return new THREE.Color(tintBack);
            case "lArmStripe":
              return new THREE.Color(tintLArmStripe);
            case "rArmStripe":
              return new THREE.Color(tintRArmStripe);
            case "lShoulderF":
              return new THREE.Color(tintLShoulderF);
            case "rShoulderF":
              return new THREE.Color(tintRShoulderF);
            case "neck":
              return new THREE.Color(tintNeck);
            case "lSleeve":
              return new THREE.Color(tintLSleeve);
            case "rSleeve":
              return new THREE.Color(tintRSleeve);
            case "shortsFront":
              return new THREE.Color(tintShortsFront);
            case "shortsBack":
              return new THREE.Color(tintShortsBack);
            default:
              return new THREE.Color("#ffffff");
          }
        };
        const thisPartCol = pickTint();

        mat.onBeforeCompile = (shader) => {
          const MAX = 8;
          const colorArr = new Array(MAX).fill(0).map(() => new THREE.Color(0xffffff));
          const posArr = new Float32Array(MAX).fill(0);

          shader.uniforms.uUseBaseGrad = { value: useBaseGrad ? 1.0 : 0.0 };
          shader.uniforms.uGradCount = { value: 0 };
          shader.uniforms.uGradColors = { value: colorArr };
          shader.uniforms.uGradPos = { value: posArr };
          shader.uniforms.uGradAngle = { value: gradAngle };

          shader.uniforms.uUseWorldGradient = { value: 1.0 };

          obj.geometry?.computeBoundingBox?.();
          const _gbb = obj.geometry?.boundingBox?.clone();
          const _wbb = _gbb ? _gbb.applyMatrix4(obj.matrixWorld) : null;

          shader.uniforms.uBBoxMin = {
            value: _wbb ? _wbb.min.clone() : bboxMin.clone(),
          };
          shader.uniforms.uBBoxMax = {
            value: _wbb ? _wbb.max.clone() : bboxMax.clone(),
          };

          shader.uniforms.uFrontDir = { value: new THREE.Vector3(0, 0, 1) };

          // Front Pattern uniforms - NO REPEAT
          shader.uniforms.uUsePattern = {
            value: showPattern && patternTex ? 1.0 : 0.0,
          };
          shader.uniforms.uPatternMap = { value: patternTex || new THREE.Texture() };
          shader.uniforms.uPatternColor = { value: pCol };
          shader.uniforms.uPatternStrength = { value: patternStrength };
          shader.uniforms.uIsUploadedPattern = { value: isUploadedPattern ? 1.0 : 0.0 };

          // Front Pattern transformation uniforms
          shader.uniforms.uPatternPosition = { value: patternPos };
          shader.uniforms.uPatternScale = { value: patternScl };
          shader.uniforms.uPatternRotation = { value: patternRotation };
          shader.uniforms.uShowPatternOnFront = { value: showPatternOnFront ? 1.0 : 0.0 };

          // Back Pattern uniforms - NO REPEAT
          shader.uniforms.uUseBackPattern = {
            value: showBackPattern && backPatternTex ? 1.0 : 0.0,
          };
          shader.uniforms.uBackPatternMap = { value: backPatternTex || new THREE.Texture() };
          shader.uniforms.uBackPatternColor = { value: backPCol };
          shader.uniforms.uBackPatternStrength = { value: backPatternStrength };
          shader.uniforms.uIsUploadedBackPattern = { value: isUploadedBackPattern ? 1.0 : 0.0 };

          // Back Pattern transformation uniforms
          shader.uniforms.uBackPatternPosition = { value: backPatternPos };
          shader.uniforms.uBackPatternScale = { value: backPatternScl };
          shader.uniforms.uBackPatternRotation = { value: backPatternRotation };
          shader.uniforms.uShowPatternOnBack = { value: showPatternOnBack ? 1.0 : 0.0 };

          // Shirt overlays
          shader.uniforms.uUseOverlayFront = {
            value: overlayFrontTex ? 1.0 : 0.0,
          };
          shader.uniforms.uOverlayFrontMap = {
            value: overlayFrontTex || new THREE.Texture(),
          };
          shader.uniforms.uUseOverlayBack = {
            value: overlayBackTex ? 1.0 : 0.0,
          };
          shader.uniforms.uOverlayBackMap = {
            value: overlayBackTex || new THREE.Texture(),
          };

          // Shorts overlays
          shader.uniforms.uUseOverlayShortsFront = {
            value: overlayShortsFrontTex ? 1.0 : 0.0,
          };
          shader.uniforms.uOverlayShortsFrontMap = {
            value: overlayShortsFrontTex || new THREE.Texture(),
          };
          shader.uniforms.uShortsFrontFlipX = { value: 0.0 };
          shader.uniforms.uShortsFrontAngle = { value: 0.0 };
          shader.uniforms.uShortsFrontUVScale = {
            value: new THREE.Vector2(1.0, 1.0),
          };
          shader.uniforms.uShortsFrontUVOffset = {
            value: new THREE.Vector2(0.0, 0.0),
          };
          shader.uniforms.uFrontMaskSoftness = { value: 0.6 };

          shader.uniforms.uUseOverlayShortsBack = {
            value: overlayShortsBackTex ? 1.0 : 0.0,
          };
          shader.uniforms.uOverlayShortsBackMap = {
            value: overlayShortsBackTex || new THREE.Texture(),
          };
          shader.uniforms.uShortsBackFlipX = { value: 0.0 };
          shader.uniforms.uShortsBackAngle = { value: 0.0 };
          shader.uniforms.uShortsBackUVScale = {
            value: new THREE.Vector2(1.0, 1.0),
          };
          shader.uniforms.uShortsBackUVOffset = {
            value: new THREE.Vector2(0.0, 0.0),
          };
          shader.uniforms.uBackMaskSoftness = { value: 0.6 };

          shader.uniforms.uFrontDir = { value: new THREE.Vector3(0, 0, 1) };

          // Text uniforms (ONLY main front & back to keep sampler count low)
          shader.uniforms.uUseText = {
            value: showText && textTex ? 1.0 : 0.0,
          };
          shader.uniforms.uTextMap = { value: textTex || new THREE.Texture() };
          shader.uniforms.uTextPosition = { value: tPos };
          shader.uniforms.uTextScale = { value: tScl };

          shader.uniforms.uUseBackText = {
            value: showBackText && backTextTex ? 1.0 : 0.0,
          };
          shader.uniforms.uBackTextMap = { value: backTextTex || new THREE.Texture() };
          shader.uniforms.uBackTextPosition = { value: btPos };
          shader.uniforms.uBackTextScale = { value: btScl };

          // Numbers
          shader.uniforms.uUseFrontNum = {
            value: showFrontNumber && frontNumTex ? 1.0 : 0.0,
          };
          shader.uniforms.uFrontNumMap = { value: frontNumTex || new THREE.Texture() };
          shader.uniforms.uFrontNumPosition = { value: fnPos };
          shader.uniforms.uFrontNumScale = { value: fnScl };

          shader.uniforms.uUseBackNum = {
            value: showBackNumber && backNumTex ? 1.0 : 0.0,
          };
          shader.uniforms.uBackNumMap = { value: backNumTex || new THREE.Texture() };
          shader.uniforms.uBackNumPosition = { value: bnPos };
          shader.uniforms.uBackNumScale = { value: bnScl };

          // Shorts numbers
          shader.uniforms.uUseShortsFrontNum = {
            value: showShortsFrontNumber && shortsFrontNumTex ? 1.0 : 0.0,
          };
          shader.uniforms.uShortsFrontNumMap = { value: shortsFrontNumTex || new THREE.Texture() };
          shader.uniforms.uShortsFrontNumPosition = { value: sfnPos };
          shader.uniforms.uShortsFrontNumScale = { value: sfnScl };

          shader.uniforms.uUseShortsBackNum = {
            value: showShortsBackNumber && shortsBackNumTex ? 1.0 : 0.0,
          };
          shader.uniforms.uShortsBackNumMap = { value: shortsBackNumTex || new THREE.Texture() };
          shader.uniforms.uShortsBackNumPosition = { value: sbnPos };
          shader.uniforms.uShortsBackNumScale = { value: sbnScl };

          // SHOULDER LOGOS - FIXED: Add shoulder logo uniforms
          shader.uniforms.uUseOverlayLShoulderF = {
            value: overlayLShoulderFTex ? 1.0 : 0.0,
          };
          shader.uniforms.uOverlayLShoulderFMap = {
            value: overlayLShoulderFTex || new THREE.Texture(),
          };
          shader.uniforms.uUseOverlayRShoulderF = {
            value: overlayRShoulderFTex ? 1.0 : 0.0,
          };
          shader.uniforms.uOverlayRShoulderFMap = {
            value: overlayRShoulderFTex || new THREE.Texture(),
          };

          shader.uniforms.uIsFront = { value: isFront };
          shader.uniforms.uIsBack = { value: isBack };
          shader.uniforms.uIsShortsFront = { value: isShortsFront };
          shader.uniforms.uIsShortsBack = { value: isShortsBack };
          shader.uniforms.uIsLShoulderF = { value: isLShoulderF };
          shader.uniforms.uIsRShoulderF = { value: isRShoulderF };

          shader.uniforms.uPartTint = { value: thisPartCol };
          shader.uniforms.uPartStrength = { value: 1.0 };

          shader.vertexShader = shader.vertexShader
            .replace(
              "void main() {",
              `
varying vec3 vWPos;
varying vec3 vWNormal;
varying vec2 vUv2;
void main() {
`
            )
            .replace(
              "#include <uv_vertex>",
              `#include <uv_vertex>
vUv2 = uv;`
            )
            .replace(
              "#include <defaultnormal_vertex>",
              `#include <defaultnormal_vertex>
vWNormal = normalize( ( modelMatrix * vec4( transformedNormal, 0.0 ) ).xyz );`
            )
            .replace(
              "#include <begin_vertex>",
              `#include <begin_vertex>
vWPos = (modelMatrix * vec4( transformed, 1.0 )).xyz;`
            );

          shader.fragmentShader = shader.fragmentShader
            .replace(
              "#include <common>",
              `#include <common>
#define MAX_STOPS 8
uniform float uUseBaseGrad;
uniform int   uGradCount;
uniform vec3  uGradColors[MAX_STOPS];
uniform float uGradPos[MAX_STOPS];
uniform float uGradAngle;

uniform float uUseWorldGradient;
uniform vec3  uBBoxMin;
uniform vec3  uBBoxMax;
varying vec3  vWPos;
varying vec3  vWNormal;
varying vec2  vUv2;

uniform float uUsePattern;
uniform sampler2D uPatternMap;
uniform vec3  uPatternColor;
uniform float uPatternStrength;
uniform float uIsUploadedPattern;

// Front Pattern transformation uniforms
uniform vec2  uPatternPosition;
uniform vec2  uPatternScale;
uniform float uPatternRotation;
uniform float uShowPatternOnFront;

// Back Pattern uniforms
uniform float uUseBackPattern;
uniform sampler2D uBackPatternMap;
uniform vec3  uBackPatternColor;
uniform float uBackPatternStrength;
uniform float uIsUploadedBackPattern;

// Back Pattern transformation uniforms
uniform vec2  uBackPatternPosition;
uniform vec2  uBackPatternScale;
uniform float uBackPatternRotation;
uniform float uShowPatternOnBack;

uniform float uUseOverlayFront;
uniform sampler2D uOverlayFrontMap;
uniform float uUseOverlayBack;
uniform sampler2D uOverlayBackMap;

// Shorts overlays
uniform float uUseOverlayShortsFront;
uniform sampler2D uOverlayShortsFrontMap;
uniform float uShortsFrontFlipX;
uniform float uShortsFrontAngle;
uniform vec2  uShortsFrontUVScale;
uniform vec2  uShortsFrontUVOffset;
uniform float uFrontMaskSoftness;

uniform float uUseOverlayShortsBack;
uniform sampler2D uOverlayShortsBackMap;
uniform float uShortsBackFlipX;
uniform float uShortsBackAngle;
uniform vec2  uShortsBackUVScale;
uniform vec2  uShortsBackUVOffset;
uniform float uBackMaskSoftness;

// SHOULDER LOGOS - FIXED: Add shoulder logo uniforms
uniform float uUseOverlayLShoulderF;
uniform sampler2D uOverlayLShoulderFMap;
uniform float uUseOverlayRShoulderF;
uniform sampler2D uOverlayRShoulderFMap;

uniform vec3  uFrontDir;

// Text uniforms (only one front, one back)
uniform float uUseText;
uniform sampler2D uTextMap;
uniform vec2  uTextPosition;
uniform vec2  uTextScale;

uniform float uUseBackText;
uniform sampler2D uBackTextMap;
uniform vec2  uBackTextPosition;
uniform vec2  uBackTextScale;

// Numbers
uniform float uUseFrontNum;
uniform sampler2D uFrontNumMap;
uniform vec2  uFrontNumPosition;
uniform vec2  uFrontNumScale;

uniform float uUseBackNum;
uniform sampler2D uBackNumMap;
uniform vec2  uBackNumPosition;
uniform vec2  uBackNumScale;

// Shorts numbers
uniform float uUseShortsFrontNum;
uniform sampler2D uShortsFrontNumMap;
uniform vec2  uShortsFrontNumPosition;
uniform vec2  uShortsFrontNumScale;

uniform float uUseShortsBackNum;
uniform sampler2D uShortsBackNumMap;
uniform vec2  uShortsBackNumPosition;
uniform vec2  uShortsBackNumScale;

uniform float uIsFront;
uniform float uIsBack;
uniform float uIsShortsFront;
uniform float uIsShortsBack;
uniform float uIsLShoulderF;
uniform float uIsRShoulderF;

uniform vec3  uPartTint;
uniform float uPartStrength;

vec2 rotate2d(vec2 p,float a){ float s=sin(a), c=cos(a); return mat2(c,-s,s,c)*p; }
vec2 gradSpaceUV(vec2 uv){ return uv; }
vec2 gradSpaceWorld(vec3 wpos){
  vec3 size = max(uBBoxMax - uBBoxMin, vec3(0.0001));
  vec3 n = clamp((wpos - uBBoxMin) / size, 0.0, 1.0);
  return n.xy;
}
vec3 gradientEval(vec2 baseUV, vec3 baseWorld){
  vec2 base = (uUseWorldGradient > 0.5) ? gradSpaceWorld(baseWorld) : gradSpaceUV(baseUV);
  vec2 p = rotate2d(base - 0.5, uGradAngle);
  float t = clamp(p.y + 0.5, 0.0, 1.0);
  if(uGradCount <= 0) return vec3(1.0);
  if(uGradCount == 1) return uGradColors[0];
  if(t <= uGradPos[0]) return uGradColors[0];
  if(t >= uGradPos[uGradCount-1]) return uGradColors[uGradCount-1];
  int idx = 0;
  for(int i=0;i<MAX_STOPS-1;i++){ if(i >= uGradCount-1) break; if(t <= uGradPos[i+1]){ idx = i; break; } }
  float a = uGradPos[idx]; float b = uGradPos[idx+1];
  float rt = (b > a) ? clamp((t - a)/(b - a), 0.0, 1.0) : 0.0;
  return mix(uGradColors[idx], uGradColors[idx+1], rt);
}

// Front Pattern function with transformations - NO REPEATING
vec2 patternSpaceUV(vec2 uv) {
  vec2 transformedUV = uv - uPatternPosition;
  transformedUV = rotate2d(transformedUV - 0.5, uPatternRotation) + 0.5;
  transformedUV = (transformedUV - 0.5) * uPatternScale + 0.5;
  vec2 flippedUV = vec2(transformedUV.x, 1.0 - transformedUV.y);
  return flippedUV;
}

// Back Pattern function with transformations - NO REPEATING
vec2 backPatternSpaceUV(vec2 uv) {
  vec2 transformedUV = uv - uBackPatternPosition;
  transformedUV = rotate2d(transformedUV - 0.5, uBackPatternRotation) + 0.5;
  transformedUV = (transformedUV - 0.5) * uBackPatternScale + 0.5;
  vec2 flippedUV = vec2(transformedUV.x, 1.0 - transformedUV.y);
  return flippedUV;
}
`
            )
            .replace(
              "#include <map_fragment>",
              `#include <map_fragment>
#ifdef USE_UV
// Base gradient
if(uUseBaseGrad > 0.5){
  diffuseColor.rgb = gradientEval(vUv2, vWPos);
}

// Part tint
float tintStr = clamp(uPartStrength, 0.0, 1.0);
vec3 tinted   = diffuseColor.rgb * uPartTint;
diffuseColor.rgb = mix(diffuseColor.rgb, tinted, tintStr);

// FRONT PATTERN
if(uUsePattern > 0.5 && uIsFront > 0.5 && uShowPatternOnFront > 0.5){
  vec2 uvp = patternSpaceUV(vUv2);
  vec4 pat = texture2D(uPatternMap, uvp);
  vec3 patternColorToUse = uIsUploadedPattern > 0.5 ? pat.rgb : uPatternColor;
  float mask = pat.a;
  float s = clamp(uPatternStrength, 0.0, 1.0);
  vec3 patternMix = mix(diffuseColor.rgb, patternColorToUse, mask);
  diffuseColor.rgb = mix(diffuseColor.rgb, patternMix, s);
}

// BACK PATTERN
if(uUseBackPattern > 0.5 && uIsBack > 0.5 && uShowPatternOnBack > 0.5){
  vec2 uvp = backPatternSpaceUV(vUv2);
  vec4 pat = texture2D(uBackPatternMap, uvp);
  vec3 patternColorToUse = uIsUploadedBackPattern > 0.5 ? pat.rgb : uBackPatternColor;
  float mask = pat.a;
  float s = clamp(uBackPatternStrength, 0.0, 1.0);
  vec3 patternMix = mix(diffuseColor.rgb, patternColorToUse, mask);
  diffuseColor.rgb = mix(diffuseColor.rgb, patternMix, s);
}

// Overlays (front/back shirts)
if(uIsFront > 0.5 && uUseOverlayFront > 0.5){
  vec4 of = texture2D(uOverlayFrontMap, vUv2);
  diffuseColor.rgb = mix(diffuseColor.rgb, of.rgb, of.a);
}
if(uIsBack > 0.5 && uUseOverlayBack > 0.5){
  vec4 ob = texture2D(uOverlayBackMap, vUv2);
  diffuseColor.rgb = mix(diffuseColor.rgb, ob.rgb, ob.a);
}

// SHOULDER LOGOS - FIXED: Add shoulder logo application
if(uIsLShoulderF > 0.5 && uUseOverlayLShoulderF > 0.5){
  vec4 shoulderLogo = texture2D(uOverlayLShoulderFMap, vUv2);
  diffuseColor.rgb = mix(diffuseColor.rgb, shoulderLogo.rgb, shoulderLogo.a);
}
if(uIsRShoulderF > 0.5 && uUseOverlayRShoulderF > 0.5){
  vec4 shoulderLogo = texture2D(uOverlayRShoulderFMap, vUv2);
  diffuseColor.rgb = mix(diffuseColor.rgb, shoulderLogo.rgb, shoulderLogo.a);
}

// SHORTS FRONT overlay
if(uIsShortsFront > 0.5 && uUseOverlayShortsFront > 0.5){
  vec3 size = max(uBBoxMax - uBBoxMin, vec3(0.0001));
  vec2 ws = (vWPos.xy - uBBoxMin.xy) / size.xy;
  vec2 suv = rotate2d(ws - 0.5, uShortsFrontAngle);
  suv = suv * uShortsFrontUVScale + 0.5 + uShortsFrontUVOffset;
  if (uShortsFrontFlipX > 0.5) suv.x = 1.0 - suv.x;
  suv.y = 1.0 - suv.y;
  suv = clamp(suv, 0.0, 1.0);
  vec4 os = texture2D(uOverlayShortsFrontMap, suv);
  diffuseColor.rgb = mix(diffuseColor.rgb, os.rgb, os.a);
}

// SHORTS BACK overlay
if(uIsShortsBack > 0.5 && uUseOverlayShortsBack > 0.5){
  vec3 size = max(uBBoxMax - uBBoxMin, vec3(0.0001));
  vec2 ws = (vWPos.xy - uBBoxMin.xy) / size.xy;
  vec2 suv = rotate2d(ws - 0.5, uShortsBackAngle);
  suv = suv * uShortsBackUVScale + 0.5 + uShortsBackUVOffset;
  if (uShortsBackFlipX > 0.5) suv.x = 1.0 - suv.x;
  suv = clamp(suv, 0.0, 1.0);
  vec4 osb = texture2D(uOverlayShortsBackMap, suv);
  diffuseColor.rgb = mix(diffuseColor.rgb, osb.rgb, osb.a);
}

// Text / Name / Numbers
if(uUseText > 0.5 && uIsFront > 0.5){
  vec2 textUV = (vUv2 - uTextPosition) / uTextScale + vec2(0.5);
  if(all(greaterThanEqual(textUV, vec2(0.0))) && all(lessThanEqual(textUV, vec2(1.0)))) {
    vec4 tex = texture2D(uTextMap, textUV);
    diffuseColor.rgb = mix(diffuseColor.rgb, tex.rgb, tex.a);
  }
}

if(uUseBackText > 0.5 && uIsBack > 0.5){
  vec2 bUV = (vUv2 - uBackTextPosition) / uBackTextScale + vec2(0.5);
  if(all(greaterThanEqual(bUV, vec2(0.0))) && all(lessThanEqual(bUV, vec2(1.0)))) {
    vec4 tex = texture2D(uBackTextMap, bUV);
    diffuseColor.rgb = mix(diffuseColor.rgb, tex.rgb, tex.a);
  }
}

// Front Number (front or back chest as needed)
if(uUseFrontNum > 0.5 && (uIsFront > 0.5 || uIsBack > 0.5)){
  vec2 nfUV = (vUv2 - uFrontNumPosition) / uFrontNumScale + vec2(0.5);
  if(all(greaterThanEqual(nfUV, vec2(0.0))) && all(lessThanEqual(nfUV, vec2(1.0)))) {
    vec4 tex = texture2D(uFrontNumMap, nfUV);
    diffuseColor.rgb = mix(diffuseColor.rgb, tex.rgb, tex.a);
  }
}

// Back Number
if(uUseBackNum > 0.5 && uIsBack > 0.5){
  vec2 nbUV = (vUv2 - uBackNumPosition) / uBackNumScale + vec2(0.5);
  if(all(greaterThanEqual(nbUV, vec2(0.0))) && all(lessThanEqual(nbUV, vec2(1.0)))) {
    vec4 tex = texture2D(uBackNumMap, nbUV);
    diffuseColor.rgb = mix(diffuseColor.rgb, tex.rgb, tex.a);
  }
}

// Shorts numbers
if(uUseShortsFrontNum > 0.5 && uIsShortsFront > 0.5){
  vec2 sfnUV = (vUv2 - uShortsFrontNumPosition) / uShortsFrontNumScale + vec2(0.5);
  if(all(greaterThanEqual(sfnUV, vec2(0.0))) && all(lessThanEqual(sfnUV, vec2(1.0)))) {
    vec4 tex = texture2D(uShortsFrontNumMap, sfnUV);
    diffuseColor.rgb = mix(diffuseColor.rgb, tex.rgb, tex.a);
  }
}

if(uUseShortsBackNum > 0.5 && uIsShortsBack > 0.5){
  vec2 sbnUV = (vUv2 - uShortsBackNumPosition) / uShortsBackNumScale + vec2(0.5);
  if(all(greaterThanEqual(sbnUV, vec2(0.0))) && all(lessThanEqual(sbnUV, vec2(1.0)))) {
    vec4 tex = texture2D(uShortsBackNumMap, sbnUV);
    diffuseColor.rgb = mix(diffuseColor.rgb, tex.rgb, tex.a);
  }
}
#endif`
            );

          const MAX_STOPS = 8;
          const maxStops = Math.min(MAX_STOPS, gradStops?.length || 0);
          shader.uniforms.uGradCount.value = maxStops;
          for (let i = 0; i < maxStops; i++) {
            const s = gradStops[i];
            const c = new THREE.Color(s.color || "#ffffff");
            shader.uniforms.uGradColors.value[i].copy(c);
            shader.uniforms.uGradPos.value[i] =
              typeof s.pos === "number" ? s.pos : 0;
          }
          mat.userData.shader = shader;
        };

        mat.needsUpdate = true;
      });
    });
  }, [
    scene,
    baseColor,
    useBaseGrad,
    gradAngle,
    gradStops,
    showPattern,
    patternTex,
    patternColor,
    patternStrength,
    isUploadedPattern,
    patternPosition,
    patternScale,
    patternRotation,
    showPatternOnFront,
    showBackPattern,
    backPatternTex,
    backPatternColor,
    backPatternStrength,
    isUploadedBackPattern,
    backPatternPosition,
    backPatternScale,
    backPatternRotation,
    showPatternOnBack,
    overlayFrontTex,
    overlayBackTex,
    overlayShortsFrontTex,
    overlayShortsBackTex,
    overlayLShoulderFTex,
    overlayRShoulderFTex,
    textPosition,
    textScale,
    backTextPosition,
    backTextScale,
    frontNumberPosition,
    frontNumberScale,
    backNumberPosition,
    backNumberScale,
    shortsFrontNumberPosition,
    shortsFrontNumberScale,
    shortsBackNumberPosition,
    shortsBackNumberScale,
    tintFront,
    tintBack,
    tintLArmStripe,
    tintRArmStripe,
    tintLShoulderF,
    tintRShoulderF,
    tintNeck,
    tintLSleeve,
    tintRSleeve,
    tintShortsFront,
    tintShortsBack,
    bboxMin,
    bboxMax,
  ]);

  // Live uniform updates
  useEffect(() => {
    if (!scene) return;
    const pCol = new THREE.Color(patternColor);
    const backPCol = new THREE.Color(backPatternColor);

    // Pattern transformation uniforms
    const patternPos = new THREE.Vector2(patternPosition.x, patternPosition.y);
    const patternScl = new THREE.Vector2(patternScale, patternScale);

    // Back Pattern transformation uniforms
    const backPatternPos = new THREE.Vector2(backPatternPosition.x, backPatternPosition.y);
    const backPatternScl = new THREE.Vector2(backPatternScale, backPatternScale);

    // Text positions and scales
    const tPos = new THREE.Vector2(...textPosition);
    const tScl = new THREE.Vector2(...textScale);
    const tPos2 = new THREE.Vector2(...textPosition2);
    const tScl2 = new THREE.Vector2(...textScale2);
    const btPos = new THREE.Vector2(...backTextPosition);
    const btScl = new THREE.Vector2(...backTextScale);
    const btPos2 = new THREE.Vector2(...backTextPosition2);
    const btScl2 = new THREE.Vector2(...backTextScale2);
    const fnPos = new THREE.Vector2(...frontNumberPosition);
    const fnScl = new THREE.Vector2(...frontNumberScale);
    const bnPos = new THREE.Vector2(...backNumberPosition);
    const bnScl = new THREE.Vector2(...backNumberScale);
    const sfnPos = new THREE.Vector2(...shortsFrontNumberPosition);
    const sfnScl = new THREE.Vector2(...shortsFrontNumberScale);
    const sbnPos = new THREE.Vector2(...shortsBackNumberPosition);
    const sbnScl = new THREE.Vector2(...shortsBackNumberScale);

    scene.traverse((obj) => {
      if (!obj.isMesh) return;
      const key = partKeyFromName(obj.name);
      const mats = Array.isArray(obj.material) ? obj.material : [obj.material];

      mats.forEach((m) => {
        if (!m) return;
        const sh = m.userData?.shader;
        if (!sh?.uniforms) return;

        applyGradStopsToShader(sh, gradStops);

        setUniformFloat(sh.uniforms.uUseBaseGrad, useBaseGrad ? 1.0 : 0.0);
        setUniformFloat(sh.uniforms.uUseWorldGradient, 1.0);
        setUniformFloat(sh.uniforms.uGradAngle, gradAngle);

        // Front Pattern uniforms
        setUniformFloat(sh.uniforms.uUsePattern, showPattern && !!patternUrl ? 1.0 : 0.0);
        if (sh.uniforms.uPatternMap && patternTex) sh.uniforms.uPatternMap.value = patternTex;
        setUniformColor(sh.uniforms.uPatternColor, pCol);
        setUniformFloat(sh.uniforms.uPatternStrength, patternStrength);
        setUniformFloat(sh.uniforms.uIsUploadedPattern, isUploadedPattern ? 1.0 : 0.0);

        // Front pattern transform
        setUniformVec2(sh.uniforms.uPatternPosition, patternPos);
        setUniformVec2(sh.uniforms.uPatternScale, patternScl);
        setUniformFloat(sh.uniforms.uPatternRotation, patternRotation);
        setUniformFloat(sh.uniforms.uShowPatternOnFront, showPatternOnFront ? 1.0 : 0.0);

        // Back Pattern
        setUniformFloat(sh.uniforms.uUseBackPattern, showBackPattern && !!backPatternUrl ? 1.0 : 0.0);
        if (sh.uniforms.uBackPatternMap && backPatternTex) sh.uniforms.uBackPatternMap.value = backPatternTex;
        setUniformColor(sh.uniforms.uBackPatternColor, backPCol);
        setUniformFloat(sh.uniforms.uBackPatternStrength, backPatternStrength);
        setUniformFloat(sh.uniforms.uIsUploadedBackPattern, isUploadedBackPattern ? 1.0 : 0.0);

        // Back pattern transform
        setUniformVec2(sh.uniforms.uBackPatternPosition, backPatternPos);
        setUniformVec2(sh.uniforms.uBackPatternScale, backPatternScl);
        setUniformFloat(sh.uniforms.uBackPatternRotation, backPatternRotation);
        setUniformFloat(sh.uniforms.uShowPatternOnBack, showPatternOnBack ? 1.0 : 0.0);

        // Shirt overlays
        setUniformFloat(sh.uniforms.uUseOverlayFront, overlayFrontTex ? 1.0 : 0.0);
        if (sh.uniforms.uOverlayFrontMap && overlayFrontTex)
          sh.uniforms.uOverlayFrontMap.value = overlayFrontTex;

        setUniformFloat(sh.uniforms.uUseOverlayBack, overlayBackTex ? 1.0 : 0.0);
        if (sh.uniforms.uOverlayBackMap && overlayBackTex)
          sh.uniforms.uOverlayBackMap.value = overlayBackTex;

        // SHOULDER LOGOS - FIXED: Add shoulder logo uniform updates
        setUniformFloat(sh.uniforms.uUseOverlayLShoulderF, overlayLShoulderFTex ? 1.0 : 0.0);
        if (sh.uniforms.uOverlayLShoulderFMap && overlayLShoulderFTex)
          sh.uniforms.uOverlayLShoulderFMap.value = overlayLShoulderFTex;

        setUniformFloat(sh.uniforms.uUseOverlayRShoulderF, overlayRShoulderFTex ? 1.0 : 0.0);
        if (sh.uniforms.uOverlayRShoulderFMap && overlayRShoulderFTex)
          sh.uniforms.uOverlayRShoulderFMap.value = overlayRShoulderFTex;

        // Shorts overlays
        setUniformFloat(sh.uniforms.uUseOverlayShortsFront, overlayShortsFrontTex ? 1.0 : 0.0);
        if (sh.uniforms.uOverlayShortsFrontMap && overlayShortsFrontTex)
          sh.uniforms.uOverlayShortsFrontMap.value = overlayShortsFrontTex;
        setUniformFloat(sh.uniforms.uShortsFrontFlipX, 0.0);
        setUniformFloat(sh.uniforms.uShortsFrontAngle, 0.0);
        setUniformVec2(sh.uniforms.uShortsFrontUVScale, new THREE.Vector2(1.0, 1.0));
        setUniformVec2(sh.uniforms.uShortsFrontUVOffset, new THREE.Vector2(0.0, 0.0));
        setUniformFloat(sh.uniforms.uFrontMaskSoftness, 0.6);

        setUniformFloat(sh.uniforms.uUseOverlayShortsBack, overlayShortsBackTex ? 1.0 : 0.0);
        if (sh.uniforms.uOverlayShortsBackMap && overlayShortsBackTex)
          sh.uniforms.uOverlayShortsBackMap.value = overlayShortsBackTex;
        setUniformFloat(sh.uniforms.uShortsBackFlipX, 0.0);
        setUniformFloat(sh.uniforms.uShortsBackAngle, 0.0);
        setUniformVec2(sh.uniforms.uShortsBackUVScale, new THREE.Vector2(1.0, 1.0));
        setUniformVec2(sh.uniforms.uShortsBackUVOffset, new THREE.Vector2(0.0, 0.0));
        setUniformFloat(sh.uniforms.uBackMaskSoftness, 0.6);

        setUniformVec3(sh.uniforms.uFrontDir, new THREE.Vector3(0, 0, 1));

        // Text uniforms (only main front/back)
        setUniformFloat(
          sh.uniforms.uUseText,
          textTex && !!textContent ? 1.0 : 0.0
        );
        if (sh.uniforms.uTextMap && textTex) sh.uniforms.uTextMap.value = textTex;
        setUniformVec2(sh.uniforms.uTextPosition, tPos);
        setUniformVec2(sh.uniforms.uTextScale, tScl);

        setUniformFloat(
          sh.uniforms.uUseBackText,
          backTextTex && !!backTextContent ? 1.0 : 0.0
        );
        if (sh.uniforms.uBackTextMap && backTextTex)
          sh.uniforms.uBackTextMap.value = backTextTex;
        setUniformVec2(sh.uniforms.uBackTextPosition, btPos);
        setUniformVec2(sh.uniforms.uBackTextScale, btScl);

        // Numbers
        setUniformFloat(
          sh.uniforms.uUseFrontNum,
          frontNumTex && !!frontNumberValue ? 1.0 : 0.0
        );
        if (sh.uniforms.uFrontNumMap && frontNumTex)
          sh.uniforms.uFrontNumMap.value = frontNumTex;
        setUniformVec2(sh.uniforms.uFrontNumPosition, fnPos);
        setUniformVec2(sh.uniforms.uFrontNumScale, fnScl);

        setUniformFloat(
          sh.uniforms.uUseBackNum,
          backNumTex && !!backNumberValue ? 1.0 : 0.0
        );
        if (sh.uniforms.uBackNumMap && backNumTex)
          sh.uniforms.uBackNumMap.value = backNumTex;
        setUniformVec2(sh.uniforms.uBackNumPosition, bnPos);
        setUniformVec2(sh.uniforms.uBackNumScale, bnScl);

        // Shorts numbers
        setUniformFloat(
          sh.uniforms.uUseShortsFrontNum,
          shortsFrontNumTex && !!shortsFrontNumberValue ? 1.0 : 0.0
        );
        if (sh.uniforms.uShortsFrontNumMap && shortsFrontNumTex)
          sh.uniforms.uShortsFrontNumMap.value = shortsFrontNumTex;
        setUniformVec2(sh.uniforms.uShortsFrontNumPosition, sfnPos);
        setUniformVec2(sh.uniforms.uShortsFrontNumScale, sfnScl);

        setUniformFloat(
          sh.uniforms.uUseShortsBackNum,
          shortsBackNumTex && !!shortsBackNumberValue ? 1.0 : 0.0
        );
        if (sh.uniforms.uShortsBackNumMap && shortsBackNumTex)
          sh.uniforms.uShortsBackNumMap.value = shortsBackNumTex;
        setUniformVec2(sh.uniforms.uShortsBackNumPosition, sbnPos);
        setUniformVec2(sh.uniforms.uShortsBackNumScale, sbnScl);

        const partCol = (() => {
          switch (key) {
            case "front":
              return tintFront;
            case "back":
              return tintBack;
            case "lArmStripe":
              return tintLArmStripe;
            case "rArmStripe":
              return tintRArmStripe;
            case "lShoulderF":
              return tintLShoulderF;
            case "rShoulderF":
              return tintRShoulderF;
            case "neck":
              return tintNeck;
            case "lSleeve":
              return tintLSleeve;
            case "rSleeve":
              return tintRSleeve;
            case "shortsFront":
              return tintShortsFront;
            case "shortsBack":
              return tintShortsBack;
            default:
              return "#ffffff";
          }
        })();
        setUniformColor(sh.uniforms.uPartTint, new THREE.Color(partCol));
        setUniformFloat(sh.uniforms.uPartStrength, 1.0);

        const k = partKeyFromName(obj.name);
        setUniformFloat(sh.uniforms.uIsFront, k === "front" ? 1.0 : 0.0);
        setUniformFloat(sh.uniforms.uIsBack, k === "back" ? 1.0 : 0.0);
        setUniformFloat(sh.uniforms.uIsShortsFront, k === "shortsFront" ? 1.0 : 0.0);
        setUniformFloat(sh.uniforms.uIsShortsBack, k === "shortsBack" ? 1.0 : 0.0);
        setUniformFloat(sh.uniforms.uIsLShoulderF, k === "lShoulderF" ? 1.0 : 0.0);
        setUniformFloat(sh.uniforms.uIsRShoulderF, k === "rShoulderF" ? 1.0 : 0.0);
      });
    });
  }, [
    scene,
    showPattern,
    patternTex,
    patternUrl,
    patternColor,
    patternStrength,
    isUploadedPattern,
    patternPosition,
    patternScale,
    patternRotation,
    showPatternOnFront,
    showBackPattern,
    backPatternTex,
    backPatternUrl,
    backPatternColor,
    backPatternStrength,
    isUploadedBackPattern,
    backPatternPosition,
    backPatternScale,
    backPatternRotation,
    showPatternOnBack,
    overlayFrontTex,
    overlayBackTex,
    overlayShortsFrontTex,
    overlayShortsBackTex,
    overlayLShoulderFTex,
    overlayRShoulderFTex,
    textTex,
    textContent,
    textPosition,
    textScale,
    backTextTex,
    backTextContent,
    backTextPosition,
    backTextScale,
    frontNumTex,
    frontNumberValue,
    frontNumberPosition,
    frontNumberScale,
    backNumTex,
    backNumberValue,
    backNumberPosition,
    backNumberScale,
    shortsFrontNumTex,
    shortsFrontNumberValue,
    shortsFrontNumberPosition,
    shortsFrontNumberScale,
    shortsBackNumTex,
    shortsBackNumberValue,
    shortsBackNumberPosition,
    shortsBackNumberScale,
    tintFront,
    tintBack,
    tintLArmStripe,
    tintRArmStripe,
    tintLShoulderF,
    tintRShoulderF,
    tintNeck,
    tintLSleeve,
    tintRSleeve,
    tintShortsFront,
    tintShortsBack,
    gradAngle,
    useBaseGrad,
    bboxMin,
    bboxMax,
    gradStops,
  ]);

  if (scene) scene.rotation.set(0, Math.PI, 0);
  return <primitive object={scene} scale={0.4} position={[0, -2.5, 0]} />;
}


function TexturedFullSleevesSoccerKit(props) {
  return (
    <Suspense fallback={null}>
      <FullSleevesSoccerKitModel {...props} />
      <Environment preset="studio" />
    </Suspense>
  );
}

// -------------------- UI CONSTANTS --------------------
const POS_MIN = -Infinity;
const POS_MAX = Infinity;

// helper to force 0..99 numeric string
function sanitizeTwoDigitNumber(value) {
  const onlyDigits = String(value || "").replace(/[^0-9]/g, "");
  const two = onlyDigits.slice(0, 2);
  return two;
}

// -------------------- Pattern Upload Component --------------------
function PatternUploadSection({ 
  title, 
  onPatternUpload, 
  uploadedPattern, 
  onClearPattern,
  patternPosition,
  onPatternPositionChange,
  patternScale,
  onPatternScaleChange,
  patternRotation,
  onPatternRotationChange,
  patternStrength,
  onPatternStrengthChange,
  showPattern,
  onShowPatternChange,
  showPatternOnPart,
  onShowPatternOnPartChange,
  partName = "Front"
}) {
  const patternFileRef = useRef(null);

  return (
    <div className="color-drawer" style={{ marginTop: 12 }}>
      <h4>{title}</h4>
      <div style={{ marginBottom: 12 }}>
        <input
          ref={patternFileRef}
          type="file"
          accept="image/png,image/jpeg,image/webp,image/svg+xml"
          style={{ display: 'none' }}
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              onPatternUpload(file);
              e.target.value = "";
            }
          }}
        />
        <button
          type="button"
          className="logo-btn"
          onClick={() => patternFileRef.current?.click()}
          style={{ width: '100%', marginBottom: 8 }}
        >
          Upload {partName} Pattern Image
        </button>
        <p style={{ fontSize: '12px', opacity: 0.8, margin: 0 }}>
          PNG, JPG, WebP, or SVG files up to 10MB
        </p>
      </div>

      {uploadedPattern && (
        <div style={{ 
          border: '1px solid #22c55e', 
          borderRadius: '8px', 
          padding: '12px', 
          marginBottom: '12px',
          background: 'rgba(34, 197, 94, 0.1)'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
              Uploaded {partName} Pattern: {uploadedPattern.name}
            </span>
            <button
              type="button"
              className="logo-btn danger"
              onClick={onClearPattern}
              style={{ padding: '4px 8px', fontSize: '12px' }}
            >
              Remove
            </button>
          </div>
          <img 
            src={uploadedPattern.url} 
            alt={`Uploaded ${partName} pattern`} 
            style={{ 
              width: '100%', 
              maxHeight: '120px', 
              objectFit: 'contain',
              borderRadius: '4px'
            }} 
          />
        </div>
      )}

      {/* Pattern Controls */}
      <div className="color-drawer" style={{ marginTop: 12 }}>
        <h4>{partName} Pattern Controls</h4>
        <div className="grid2">
          <label>Show {partName} Pattern</label>
          <input
            type="checkbox"
            checked={showPattern}
            onChange={(e) => onShowPatternChange(e.target.checked)}
          />
          <label>Show on {partName}</label>
          <input
            type="checkbox"
            checked={showPatternOnPart}
            onChange={(e) => onShowPatternOnPartChange(e.target.checked)}
          />
          <label>X-Axis</label>
          <input
            type="range"
            min={-1}
            max={2}
            step="0.01"
            value={patternPosition.x}
            onChange={(e) =>
              onPatternPositionChange({
                ...patternPosition,
                x: parseFloat(e.target.value),
              })
            }
          />
          <label>Y-Axis</label>
          <input
            type="range"
            min={-1}
            max={2}
            step="0.01"
            value={patternPosition.y}
            onChange={(e) =>
              onPatternPositionChange({
                ...patternPosition,
                y: parseFloat(e.target.value),
              })
            }
          />
          <label>Scale</label>
          <input
            type="range"
            min="0.1"
            max="3"
            step="0.01"
            value={patternScale}
            onChange={(e) =>
              onPatternScaleChange(parseFloat(e.target.value))
            }
          />
          <label>Rotation</label>
          <input
            type="range"
            min="-3.14"
            max="3.14"
            step="0.01"
            value={patternRotation}
            onChange={(e) =>
              onPatternRotationChange(parseFloat(e.target.value))
            }
          />
          <label>Pattern Strength</label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={patternStrength}
            onChange={(e) =>
              onPatternStrengthChange(parseFloat(e.target.value))
            }
          />
        </div>
        
        {/* Info for uploaded patterns */}
        {uploadedPattern && (
          <div style={{ 
            padding: '12px', 
            background: 'rgba(34, 197, 94, 0.1)', 
            borderRadius: '8px',
            border: '1px solid rgba(34, 197, 94, 0.3)',
            marginTop: '12px'
          }}>
            <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
              <strong>Note:</strong> Uploaded patterns will not repeat and will use their original colors.
              Pattern color controls do not affect uploaded images.
            </p>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Use X-Axis, Y-Axis, Scale, and Rotation controls to position, resize and rotate your pattern.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

// -------------------- Logo Upload Component --------------------
function LogoUploadSection({ 
  onLogoUpload, 
  logoLayers, 
  selectedLogoId, 
  onSelectLogo, 
  onRemoveLogo, 
  onUpdateLogo,
  onDuplicateLogo,
  onMoveLogo,
  onReplaceLogo,
  onAddLogoToPart
}) {
  const logoFileRef = useRef(null);
  const selectedLogo = logoLayers.find(l => l.id === selectedLogoId);

  return (
    <div className="color-drawer" style={{ marginTop: 12 }}>
      <h4>Logo Management</h4>
      
      {/* Upload Button */}
      <div style={{ marginBottom: 12 }}>
        <input
          ref={logoFileRef}
          type="file"
          accept="image/png,image/jpeg,image/webp,image/svg+xml"
          style={{ display: 'none' }}
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              onLogoUpload(file);
              e.target.value = "";
            }
          }}
        />
        <button
          type="button"
          className="logo-btn"
          onClick={() => logoFileRef.current?.click()}
          style={{ width: '100%', marginBottom: 8 }}
        >
          Upload Logo
        </button>
      </div>

      {/* Quick Add Logo to Parts */}
      <div style={{ marginBottom: 12 }}>
        <h5>Quick Add Logo To:</h5>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <button
            type="button"
            className="logo-btn"
            onClick={() => onAddLogoToPart('front')}
            style={{ padding: '6px 10px', fontSize: '12px' }}
          >
            Shirt Front
          </button>
          <button
            type="button"
            className="logo-btn"
            onClick={() => onAddLogoToPart('back')}
            style={{ padding: '6px 10px', fontSize: '12px' }}
          >
            Shirt Back
          </button>
          <button
            type="button"
            className="logo-btn"
            onClick={() => onAddLogoToPart('lShoulderF')}
            style={{ padding: '6px 10px', fontSize: '12px' }}
          >
            Left Shoulder
          </button>
          <button
            type="button"
            className="logo-btn"
            onClick={() => onAddLogoToPart('rShoulderF')}
            style={{ padding: '6px 10px', fontSize: '12px' }}
          >
            Right Shoulder
          </button>
          <button
            type="button"
            className="logo-btn"
            onClick={() => onAddLogoToPart('shortsFront')}
            style={{ padding: '6px 10px', fontSize: '12px' }}
          >
            Shorts Front
          </button>
          <button
            type="button"
            className="logo-btn"
            onClick={() => onAddLogoToPart('shortsBack')}
            style={{ padding: '6px 10px', fontSize: '12px' }}
          >
            Shorts Back
          </button>
        </div>
      </div>

      {/* Logo List */}
      {logoLayers.length > 0 && (
        <div style={{ marginBottom: 12 }}>
          <h5>Uploaded Logos ({logoLayers.length})</h5>
          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {logoLayers.map((logo) => (
              <div
                key={logo.id}
                className={`logo-item ${selectedLogoId === logo.id ? 'selected' : ''}`}
                style={{
                  padding: '8px',
                  border: '1px solid rgba(255,255,255,0.2)',
                  borderRadius: '6px',
                  marginBottom: '6px',
                  cursor: 'pointer',
                  background: selectedLogoId === logo.id ? 'rgba(34, 197, 94, 0.2)' : 'transparent'
                }}
                onClick={() => onSelectLogo(logo.id)}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <img 
                    src={logo.src} 
                    alt="Logo" 
                    style={{ 
                      width: '30px', 
                      height: '30px', 
                      objectFit: 'contain',
                      borderRadius: '4px'
                    }} 
                  />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '12px', fontWeight: 'bold' }}>
                      {logo.name || 'Logo'}
                    </div>
                    <div style={{ fontSize: '10px', opacity: 0.7 }}>
                      {logo.part} {logo.side ? `(${logo.side})` : ''}
                    </div>
                  </div>
                  <button
                    type="button"
                    className="logo-btn danger"
                    onClick={(e) => {
                      e.stopPropagation();
                      onRemoveLogo(logo.id);
                    }}
                    style={{ padding: '2px 6px', fontSize: '10px' }}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Logo Controls */}
      {selectedLogo && (
        <div style={{ 
          border: '1px solid rgba(34, 197, 94, 0.3)', 
          borderRadius: '8px', 
          padding: '12px',
          background: 'rgba(34, 197, 94, 0.1)'
        }}>
          <h5>Logo Controls - {selectedLogo.part} {selectedLogo.side ? `(${selectedLogo.side})` : ''}</h5>
          
          {/* Part Selection */}
          <div className="grid2" style={{ marginBottom: '12px' }}>
            <label>Placement</label>
            <select
              value={selectedLogo.part}
              onChange={(e) => onUpdateLogo(selectedLogo.id, { part: e.target.value })}
              style={{ padding: '6px', borderRadius: '4px', background: '#1a1a1a', color: 'white', border: '1px solid rgba(255,255,255,0.2)' }}
            >
              <option value="front">Shirt Front</option>
              <option value="back">Shirt Back</option>
              <option value="lShoulderF">Left Shoulder (Front)</option>
              <option value="rShoulderF">Right Shoulder (Front)</option>
              <option value="shortsFront">Shorts Front</option>
              <option value="shortsBack">Shorts Back</option>
            </select>
          </div>

          <div className="grid2">
            <label>Position X</label>
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={selectedLogo.x}
              onChange={(e) => onUpdateLogo(selectedLogo.id, { x: parseFloat(e.target.value) })}
            />
            <label>Position Y</label>
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={selectedLogo.y}
              onChange={(e) => onUpdateLogo(selectedLogo.id, { y: parseFloat(e.target.value) })}
            />
            <label>Scale</label>
            <input
              type="range"
              min="0.01"
              max="1"
              step="0.01"
              value={selectedLogo.scale}
              onChange={(e) => onUpdateLogo(selectedLogo.id, { scale: parseFloat(e.target.value) })}
            />
            <label>Rotation</label>
            <input
              type="range"
              min="-3.14"
              max="3.14"
              step="0.01"
              value={selectedLogo.rot}
              onChange={(e) => onUpdateLogo(selectedLogo.id, { rot: parseFloat(e.target.value) })}
            />
            <label>Opacity</label>
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={selectedLogo.opacity}
              onChange={(e) => onUpdateLogo(selectedLogo.id, { opacity: parseFloat(e.target.value) })}
            />
          </div>
          
          <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
            <button
              type="button"
              className="logo-btn"
              onClick={() => onDuplicateLogo(selectedLogo.id)}
              style={{ flex: 1, padding: '6px' }}
            >
              Duplicate
            </button>
            <button
              type="button"
              className="logo-btn"
              onClick={() => onMoveLogo(selectedLogo.id, 'up')}
              style={{ flex: 1, padding: '6px' }}
            >
              Move Up
            </button>
            <button
              type="button"
              className="logo-btn"
              onClick={() => onMoveLogo(selectedLogo.id, 'down')}
              style={{ flex: 1, padding: '6px' }}
            >
              Move Down
            </button>
          </div>

          {/* Replace Logo */}
          <div style={{ marginTop: '12px' }}>
            <input
              type="file"
              accept="image/png,image/jpeg,image/webp,image/svg+xml"
              style={{ display: 'none' }}
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) {
                  onReplaceLogo(selectedLogo.id, file);
                  e.target.value = "";
                }
              }}
            />
            <button
              type="button"
              className="logo-btn"
              onClick={() => document.querySelector('input[type="file"]')?.click()}
              style={{ width: '100%', padding: '6px' }}
            >
              Replace Logo
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// -------------------- 360 Snapshot Component --------------------
function SnapshotSection({ snapshots, onTakeSnapshots, onClearSnapshots, isTakingSnapshots }) {
  const [snapshotError, setSnapshotError] = useState(null);

  const handleTakeSnapshots = async () => {
    setSnapshotError(null);
    try {
      await onTakeSnapshots();
    } catch (error) {
      setSnapshotError('Failed to capture snapshots. Please try again.');
      console.error('Snapshot capture failed:', error);
    }
  };

  const downloadSnapshot = (snapshot, index) => {
    try {
      const link = document.createElement('a');
      link.download = `full-sleeves-soccer-kit-${snapshot.angle}deg-${Date.now()}.png`;
      link.href = snapshot.data;
      link.click();
    } catch (error) {
      console.error('Download failed:', error);
      alert('Download failed. Please try again.');
    }
  };

  const downloadAllSnapshots = () => {
    snapshots.forEach((snapshot, index) => {
      setTimeout(() => {
        downloadSnapshot(snapshot, index);
      }, index * 100);
    });
  };

  return (
    <div className="color-drawer" style={{ marginTop: 12 }}>
      <h4>360° Snapshots</h4>
      
      {snapshotError && (
        <div style={{
          padding: '12px',
          background: 'rgba(239, 68, 68, 0.2)',
          border: '1px solid rgba(239, 68, 68, 0.5)',
          borderRadius: '8px',
          marginBottom: '12px',
          color: '#fca5a5'
        }}>
          <strong>Error:</strong> {snapshotError}
        </div>
      )}
      
      <div style={{ marginBottom: 12 }}>
        <button
          type="button"
          className="logo-btn"
          onClick={handleTakeSnapshots}
          disabled={isTakingSnapshots}
          style={{ width: '100%', marginBottom: 8 }}
        >
          {isTakingSnapshots ? (
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
              <div style={{ 
                width: '16px', 
                height: '16px', 
                border: '2px solid transparent',
                borderTop: '2px solid white',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}></div>
              Capturing Snapshots...
            </span>
          ) : 'Take 360° Snapshots'}
        </button>
        
        {snapshots.length > 0 && (
          <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
            <button
              type="button"
              className="logo-btn danger"
              onClick={onClearSnapshots}
              style={{ flex: 1 }}
            >
              Clear Snapshots
            </button>
            <button
              type="button"
              className="logo-btn"
              onClick={downloadAllSnapshots}
              style={{ flex: 1 }}
            >
              Download All
            </button>
          </div>
        )}
      </div>

      {snapshots.length > 0 && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
            <h5 style={{ margin: 0 }}>Saved Snapshots ({snapshots.length})</h5>
            <span style={{ fontSize: '12px', opacity: 0.7 }}>
              Click on any image to download
            </span>
          </div>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(3, 1fr)', 
            gap: '10px',
            maxHeight: '400px',
            overflowY: 'auto',
            padding: '8px',
            background: 'rgba(255,255,255,0.05)',
            borderRadius: '8px'
          }}>
            {snapshots.map((snapshot, index) => (
              <div
                key={snapshot.id}
                style={{
                  border: '2px solid rgba(34, 197, 94, 0.3)',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  position: 'relative',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onClick={() => downloadSnapshot(snapshot, index)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.borderColor = 'rgba(34, 197, 94, 0.6)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.borderColor = 'rgba(34, 197, 94, 0.3)';
                }}
              >
                <img 
                  src={snapshot.data} 
                  alt={`Full Sleeves Soccer Kit ${snapshot.angle}°`}
                  style={{
                    width: '100%',
                    height: '100px',
                    objectFit: 'contain',
                    background: '#0f172a'
                  }}
                  onError={(e) => {
                    console.error('Image failed to load:', snapshot);
                    e.target.style.background = 'rgba(239, 68, 68, 0.1)';
                    e.target.alt = 'Image failed to load';
                  }}
                />
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                  color: 'white',
                  fontSize: '11px',
                  padding: '4px',
                  textAlign: 'center'
                }}>
                  {snapshot.angle}°
                </div>
                <div style={{
                  position: 'absolute',
                  top: '4px',
                  right: '4px',
                  background: 'rgba(0,0,0,0.7)',
                  color: 'white',
                  fontSize: '10px',
                  padding: '2px 4px',
                  borderRadius: '4px'
                }}>
                  #{index + 1}
                </div>
              </div>
            ))}
          </div>
          
          <div style={{ 
            marginTop: '12px',
            padding: '8px',
            background: 'rgba(34, 197, 94, 0.1)',
            borderRadius: '6px',
            border: '1px solid rgba(34, 197, 94, 0.2)'
          }}>
            <p style={{ margin: 0, fontSize: '12px', textAlign: 'center' }}>
              <strong>Tip:</strong> Click on any snapshot to download it
            </p>
          </div>
        </div>
      )}

      {snapshots.length === 0 && !isTakingSnapshots && (
        <div style={{ 
          padding: '30px 20px', 
          textAlign: 'center',
          background: 'rgba(255,255,255,0.05)',
          borderRadius: '12px',
          border: '2px dashed rgba(255,255,255,0.2)',
          marginTop: '12px'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '12px', opacity: 0.5 }}>📸</div>
          <h5 style={{ margin: '0 0 8px 0', color: '#e5e7eb' }}>No Snapshots Yet</h5>
          <p style={{ margin: 0, fontSize: '14px', opacity: 0.7, lineHeight: '1.4' }}>
            Click "Take 360° Snapshots" to capture images of your design from all angles.
          </p>
        </div>
      )}

      {isTakingSnapshots && snapshots.length === 0 && (
        <div style={{ 
          padding: '30px 20px', 
          textAlign: 'center',
          background: 'rgba(34, 197, 94, 0.1)',
          borderRadius: '12px',
          border: '2px dashed rgba(34, 197, 94, 0.3)',
          marginTop: '12px'
        }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '3px solid transparent',
            borderTop: '3px solid #22c55e',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <h5 style={{ margin: '0 0 8px 0', color: '#22c55e' }}>Taking Snapshots</h5>
          <p style={{ margin: 0, fontSize: '14px', opacity: 0.8, lineHeight: '1.4' }}>
            We're capturing 12 different angles of your 3D model...
          </p>
        </div>
      )}
    </div>
  );
}

// -------------------- MAIN CONFIGURATOR --------------------
export default function FullSleevesSoccerKitConfigurator() {


const navigate = useNavigate();

const handleProceed = () => {
  navigate("/details");
};



  const [activeTab, setActiveTab] = useState("Categories");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selected, setSelected] = useState(ONLINE_DESIGNS[0]);
  const [selectedFullSleeve, setSelectedFullSleeve] = useState(FULL_SLEEVES_STYLES[0]);
  
  // Front Pattern controls
  const [patternColor, setPatternColor] = useState("#000000");
  const [patternStrength, setPatternStrength] = useState(1);
  const [selectedPattern, setSelectedPattern] = useState(PATTERNS[6]);
  const [showPattern, setShowPattern] = useState(true);
  const [showPatternOnFront, setShowPatternOnFront] = useState(true);

  // Front UPLOADED PATTERN CONTROLS
  const [uploadedPattern, setUploadedPattern] = useState(null);
  const [uploadedPatternUrl, setUploadedPatternUrl] = useState(null);
  const [patternPosition, setPatternPosition] = useState({ x: 0, y: 0 });
  const [patternScale, setPatternScale] = useState(1);
  const [patternRotation, setPatternRotation] = useState(0);

  // Back Pattern controls
  const [backPatternColor, setBackPatternColor] = useState("#000000");
  const [backPatternStrength, setBackPatternStrength] = useState(0);
  const [selectedBackPattern, setSelectedBackPattern] = useState(PATTERNS[6]);
  const [showBackPattern, setShowBackPattern] = useState(false);
  const [showPatternOnBack, setShowPatternOnBack] = useState(false);

  // Back UPLOADED PATTERN CONTROLS
  const [uploadedBackPattern, setUploadedBackPattern] = useState(null);
  const [uploadedBackPatternUrl, setUploadedBackPatternUrl] = useState(null);
  const [backPatternPosition, setBackPatternPosition] = useState({ x: 0, y: 0 });
  const [backPatternScale, setBackPatternScale] = useState(1);
  const [backPatternRotation, setBackPatternRotation] = useState(0);

  // Front STATIC PATTERN CONTROLS (separate from uploaded patterns)
  const [staticPatternPosition, setStaticPatternPosition] = useState({ x: -0.2, y: -0.34 });
  const [staticPatternScale, setStaticPatternScale] = useState(+1.399);
  const [staticPatternRotation, setStaticPatternRotation] = useState(0);

  // Back STATIC PATTERN CONTROLS (separate from uploaded patterns)
  const [staticBackPatternPosition, setStaticBackPatternPosition] = useState({ x: 0, y: 0 });
  const [staticBackPatternScale, setStaticBackPatternScale] = useState(1);
  const [staticBackPatternRotation, setStaticBackPatternRotation] = useState(0);

  // ---------- Logo Layers ----------
  const [logoLayers, setLogoLayers] = useState([]);
  const [selectedLogoId, setSelectedLogoId] = useState(null);

  const overlayFrontTex = useLogosCompositeTexture(
    logoLayers.filter((l) => l.enabled && l.part === "front"),
    1024
  );
  const overlayBackTex = useLogosCompositeTexture(
    logoLayers.filter((l) => l.enabled && l.part === "back"),
    1024
  );
  const overlayShortsFrontTex = useLogosCompositeTexture(
    logoLayers.filter((l) => l.enabled && l.part === "shortsFront"),
    1024
  );
  const overlayShortsBackTex = useLogosCompositeTexture(
    logoLayers.filter((l) => l.enabled && l.part === "shortsBack"),
    1024
  );
  const overlayLShoulderFTex = useLogosCompositeTexture(
    logoLayers.filter((l) => l.enabled && l.part === "lShoulderF"),
    1024
  );
  const overlayRShoulderFTex = useLogosCompositeTexture(
    logoLayers.filter((l) => l.enabled && l.part === "rShoulderF"),
    1024
  );

  // ---------- 360 Snapshot State ----------
  const [snapshots, setSnapshots] = useState([]);
  const [isTakingSnapshots, setIsTakingSnapshots] = useState(false);

  const acceptTypes = ["image/png", "image/jpeg", "image/webp", "image/svg+xml"];
  const MAX_MB = 10;
  function validateFile(file) {
    if (!file) return "File missing.";
    if (!acceptTypes.includes(file.type)) return "Invalid file type. Use PNG, JPG, SVG or WebP.";
    if (file.size > MAX_MB * 1024 * 1024) return `File too large. Max ${MAX_MB} MB.`;
    return null;
  }

  // Front Upload pattern handler
  const handlePatternUpload = (file) => {
    const err = validateFile(file);
    if (err) {
      alert(err);
      return;
    }
    
    const blobUrl = URL.createObjectURL(file);
    setUploadedPattern({
      name: file.name,
      url: blobUrl,
      blob: blobUrl
    });
    setUploadedPatternUrl(blobUrl);
    setShowPattern(true);
  };

  // Clear front uploaded pattern
  const clearUploadedPattern = () => {
    if (uploadedPattern?.blob) {
      URL.revokeObjectURL(uploadedPattern.blob);
    }
    setUploadedPattern(null);
    setUploadedPatternUrl(null);
    setShowPattern(false);
  };

  // Back Upload pattern handler
  const handleBackPatternUpload = (file) => {
    const err = validateFile(file);
    if (err) {
      alert(err);
      return;
    }
    
    const blobUrl = URL.createObjectURL(file);
    setUploadedBackPattern({
      name: file.name,
      url: blobUrl,
      blob: blobUrl
    });
    setUploadedBackPatternUrl(blobUrl);
    setShowBackPattern(true);
  };

  // Clear back uploaded pattern
  const clearUploadedBackPattern = () => {
    if (uploadedBackPattern?.blob) {
      URL.revokeObjectURL(uploadedBackPattern.blob);
    }
    setUploadedBackPattern(null);
    setUploadedBackPatternUrl(null);
    setShowBackPattern(false);
  };

  // Logo management functions
  const countByPart = (part) => logoLayers.filter((l) => l.part === part).length;

  function clampToInfiniteBounds(x, y) {
    return { x, y };
  }

  const pushDefaultLogo = (part, patch = {}, layersRef) => {
    const baseLayers = layersRef || logoLayers;
    let side = patch.side;
    if (part === "shortsBack") {
      side = "center";
    } else if (part === "shortsFront") {
      side = side || "left";
    }

    const countForPart = baseLayers.filter((l) => {
      if (l.part !== part) return false;
      if (part === "shortsFront") return (l.side || "left") === (side || "left");
      if (part === "shortsBack") return true;
      if (part === "lShoulderF" || part === "rShoulderF" || part === "lShoulderB" || part === "rShoulderB") return true;
      return true;
    }).length;

    const offsetStep = 0.04;

    if (part === "shortsFront" || part === "shortsBack") {
      const base =
        part === "shortsFront"
          ? side === "right"
            ? DEFAULT_SHORTS_RIGHT_FRONT
            : DEFAULT_SHORTS_LEFT_FRONT
          : DEFAULT_SHORTS_BACK_CENTER;

      const offsetY = base.y + countForPart * offsetStep;
      const clamped = clampToInfiniteBounds(base.x, offsetY);

      return {
        id: `logo-${Math.random().toString(36).slice(2)}`,
        name: "Logo",
        src: "",
        x: clamped.x,
        y: clamped.y,
        scale: base.scale,
        rot: base.rot,
        opacity: base.opacity,
        blend: base.blend,
        enabled: true,
        part,
        side,
      };
    }

    if (part === "lShoulderF" || part === "rShoulderF" || part === "lShoulderB" || part === "rShoulderB") {
      let base;
      if (part === "lShoulderF") base = DEFAULT_L_SHOULDER_F;
      else if (part === "rShoulderF") base = DEFAULT_R_SHOULDER_F;
      else if (part === "lShoulderB") base = DEFAULT_L_SHOULDER_B;
      else if (part === "rShoulderB") base = DEFAULT_R_SHOULDER_B;
      else base = DEFAULT_FRONT_POS_1;

      const offsetY = base.y + countForPart * offsetStep;
      const clamped = clampToInfiniteBounds(base.x, offsetY);

      return {
        id: `logo-${Math.random().toString(36).slice(2)}`,
        name: "Logo",
        src: "",
        x: clamped.x,
        y: clamped.y,
        scale: base.scale,
        rot: base.rot,
        opacity: base.opacity,
        blend: base.blend,
        enabled: true,
        part,
      };
    }

    const base = part === "front" ? DEFAULT_FRONT_POS_1 : DEFAULT_BACK_POS;
    const x = base.x;
    const y = base.y + countForPart * offsetStep;

    return {
      id: `logo-${Math.random().toString(36).slice(2)}`,
      name: "Logo",
      src: "",
      x,
      y,
      scale: base.scale,
      rot: base.rot,
      opacity: base.opacity,
      blend: base.blend,
      enabled: true,
      part,
    };
  };

  const handleLogoUpload = (file) => {
    const err = validateFile(file);
    if (err) {
      alert(err);
      return;
    }
    const blobUrl = URL.createObjectURL(file);
    const base = pushDefaultLogo("front", {}, logoLayers);
    const newLogo = {
      ...base,
      name: file.name || "Logo",
      src: blobUrl,
      __blob: blobUrl,
    };
    setLogoLayers(prev => [...prev, newLogo]);
    setSelectedLogoId(newLogo.id);
  };

  const handleAddLogoToPart = (part) => {
    if (logoLayers.length === 0) {
      alert("Please upload a logo first!");
      return;
    }
    
    // Use the first uploaded logo as template
    const firstLogo = logoLayers[0];
    const base = pushDefaultLogo(part, {}, logoLayers);
    const newLogo = {
      ...base,
      name: `${firstLogo.name} (${part})`,
      src: firstLogo.src,
      part: part,
    };
    setLogoLayers(prev => [...prev, newLogo]);
    setSelectedLogoId(newLogo.id);
  };

  const removeLogo = (id) => {
    setLogoLayers((prev) => {
      const f = prev.find((l) => l.id === id);
      if (f?.__blob) URL.revokeObjectURL(f.__blob);
      if (selectedLogoId === id) {
        setSelectedLogoId(null);
      }
      return prev.filter((l) => l.id !== id);
    });
  };

  const updateLogo = (id, patch) => {
    setLogoLayers((prev) => {
      const idx = prev.findIndex((l) => l.id === id);
      if (idx === -1) return prev;
      const L = prev[idx];
      const result = { ...L, ...patch };

      if (result.part === "shortsFront" || result.part === "shortsBack") {
        const side = result.part === "shortsBack" ? "center" : result.side || "left";
        const { x, y } = clampToInfiniteBounds(result.x, result.y);
        result.x = x;
        result.y = y;
        result.side = side;
      } else if (result.part === "lShoulderF" || result.part === "rShoulderF" || result.part === "lShoulderB" || result.part === "rShoulderB") {
        const { x, y } = clampToInfiniteBounds(result.x, result.y);
        result.x = x;
        result.y = y;
      }

      const next = [...prev];
      next[idx] = result;
      return next;
    });
  };

  const moveLogo = (id, dir) =>
    setLogoLayers((prev) => {
      const idx = prev.findIndex((l) => l.id === id);
      if (idx === -1) return prev;
      const { part, side } = prev[idx];
      const same = prev
        .map((l, i) => [
          l.part === part && (part === "shortsFront" ? l.side === side : true),
          i,
        ])
        .filter(([ok]) => ok)
        .map(([, i]) => i);

      const local = same.indexOf(idx);
      const swapLocal = dir === "up" ? local - 1 : local + 1;
      if (swapLocal < 0 || swapLocal >= same.length) return prev;

      const swap = same[swapLocal];
      const next = [...prev];
      [next[idx], next[swap]] = [next[swap], next[idx]];
      return next;
    });

  const duplicateLogo = (id) => {
    setLogoLayers((prev) => {
      const L = prev.find((l) => l.id === id);
      if (!L) return prev;
      const { __blob, id: _old, ...rest } = L;
      const copy = {
        ...rest,
        id: `logo-${Math.random().toString(36).slice(2)}`,
        name: `${L.name || "Logo"} (copy)`,
        x: Math.min(1.0, L.x + 0.02),
        y: Math.min(1.0, L.y + 0.04),
      };
      if (copy.part === "shortsFront" || copy.part === "shortsBack") {
        const side = copy.part === "shortsBack" ? "center" : copy.side || "left";
        const c = clampToInfiniteBounds(copy.x, copy.y);
        copy.x = c.x;
        copy.y = c.y;
        copy.side = side;
      } else if (copy.part === "lShoulderF" || copy.part === "rShoulderF" || copy.part === "lShoulderB" || copy.part === "rShoulderB") {
        const c = clampToInfiniteBounds(copy.x, copy.y);
        copy.x = c.x;
        copy.y = c.y;
      }
      setSelectedLogoId(copy.id);
      return [...prev, copy];
    });
  };

  const handleReplaceLogo = (id, file) => {
    const err = validateFile(file);
    if (err) {
      alert(err);
      return;
    }
    const blobUrl = URL.createObjectURL(file);
    setLogoLayers((prev) =>
      prev.map((l) => {
        if (l.id !== id) return l;
        if (l.__blob) URL.revokeObjectURL(l.__blob);
        return {
          ...l,
          name: file.name || l.name || "Logo",
          src: blobUrl,
          __blob: blobUrl,
        };
      })
    );
  };

  // Text / Name / Numbers state - ALL INITIALIZED AS EMPTY/HIDDEN
  const [textContent, setTextContent] = useState("");
  const [showText, setShowText] = useState(false);
  const [textColor, setTextColor] = useState("#ffffff");
  const [textStroke, setTextStroke] = useState("#000000");
  const [textStrokeW, setTextStrokeW] = useState(4);
  const [textPosition, setTextPosition] = useState({ x: 0.28, y: 0.3 });
  const [textScale, setTextScale] = useState(0.2);
  const [textFontSize, setTextFontSize] = useState(90);
  const [textLetterSpacing, setTextLetterSpacing] = useState(0);

  const [textContent2, setTextContent2] = useState("");
  const [showText2, setShowText2] = useState(false);
  const [textColor2, setTextColor2] = useState("#ffffff");
  const [textStroke2, setTextStroke2] = useState("#000000");
  const [textStrokeW2, setTextStrokeW2] = useState(4);
  const [textPosition2, setTextPosition2] = useState({ x: 0.28, y: 0.5 });
  const [textScale2, setTextScale2] = useState(0.2);
  const [textFontSize2, setTextFontSize2] = useState(90);
  const [textLetterSpacing2, setTextLetterSpacing2] = useState(0);

  const [backTextContent, setBackTextContent] = useState("");
  const [showBackText, setShowBackText] = useState(false);
  const [backTextColor, setBackTextColor] = useState("#ffffff");
  const [backTextStroke, setBackTextStroke] = useState("#000000");
  const [backTextStrokeW, setBackTextStrokeW] = useState(4);
  const [backTextPosition, setBackTextPosition] = useState({ x: 0.7, y: 0.62 });
  const [backTextScale, setBackTextScale] = useState(0.2);
  const [backTextFontSize, setBackTextFontSize] = useState(90);
  const [backTextLetterSpacing, setBackTextLetterSpacing] = useState(0);

  const [backTextContent2, setBackTextContent2] = useState("");
  const [showBackText2, setShowBackText2] = useState(false);
  const [backTextColor2, setBackTextColor2] = useState("#ffffff");
  const [backTextStroke2, setBackTextStroke2] = useState("#000000");
  const [backTextStrokeW2, setBackTextStrokeW2] = useState(4);
  const [backTextPosition2, setBackTextPosition2] = useState({ x: 0.7, y: 0.75 });
  const [backTextScale2, setBackTextScale2] = useState(0.2);
  const [backTextFontSize2, setBackTextFontSize2] = useState(90);
  const [backTextLetterSpacing2, setBackTextLetterSpacing2] = useState(0);

  const [frontNumberValue, setFrontNumberValue] = useState("");
  const [showFrontNumber, setShowFrontNumber] = useState(false);
  const [frontNumberColor, setFrontNumberColor] = useState("#ffffff");
  const [frontNumberStroke, setFrontNumberStroke] = useState("#000000");
  const [frontNumberStrokeW, setFrontNumberStrokeW] = useState(4);
  const [frontNumberPosition, setFrontNumberPosition] = useState({
    x: 0.45,
    y: 0.45,
  });
  const [frontNumberScale, setFrontNumberScale] = useState({ x: 0.28, y: 0.28 });
  const [frontNumberFontSize, setFrontNumberFontSize] = useState(140);
  const [frontNumberLetterSpacing, setFrontNumberLetterSpacing] = useState(0);

  const [backNumberValue, setBackNumberValue] = useState("");
  const [showBackNumber, setShowBackNumber] = useState(false);
  const [backNumberColor, setBackNumberColor] = useState("#ffffff");
  const [backNumberStroke, setBackNumberStroke] = useState("#000000");
  const [backNumberStrokeW, setBackNumberStrokeW] = useState(4);
  const [backNumberPosition, setBackNumberPosition] = useState({
    x: 0.73,
    y: 0.8,
  });
  const [backNumberScale, setBackNumberScale] = useState({ x: 0.25, y: 0.25 });
  const [backNumberFontSize, setBackNumberFontSize] = useState(160);
  const [backNumberLetterSpacing, setBackNumberLetterSpacing] = useState(0);

  const [shortsFrontNumberValue, setShortsFrontNumberValue] = useState("");
  const [showShortsFrontNumber, setShowShortsFrontNumber] = useState(false);
  const [shortsFrontNumberColor, setShortsFrontNumberColor] = useState("#ffffff");
  const [shortsFrontNumberStroke, setShortsFrontNumberStroke] = useState("#000000");
  const [shortsFrontNumberStrokeW, setShortsFrontNumberStrokeW] = useState(4);
  const [shortsFrontNumberPosition, setShortsFrontNumberPosition] = useState({
    x: 0.4,
    y: 0.8
  });
  const [shortsFrontNumberScale, setShortsFrontNumberScale] = useState({ x: 0.25, y: 0.25 });
  const [shortsFrontNumberFontSize, setShortsFrontNumberFontSize] = useState(80);
  const [shortsFrontNumberLetterSpacing, setShortsFrontNumberLetterSpacing] = useState(0);

  const [shortsBackNumberValue, setShortsBackNumberValue] = useState("");
  const [showShortsBackNumber, setShowShortsBackNumber] = useState(false);
  const [shortsBackNumberColor, setShortsBackNumberColor] = useState("#ffffff");
  const [shortsBackNumberStroke, setShortsBackNumberStroke] = useState("#000000");
  const [shortsBackNumberStrokeW, setShortsBackNumberStrokeW] = useState(4);
  const [shortsBackNumberPosition, setShortsBackNumberPosition] = useState({
    x: 0.5,
    y: 0.3
  });
  const [shortsBackNumberScale, setShortsBackNumberScale] = useState({ x: 0.35, y: 0.35 });
  const [shortsBackNumberFontSize, setShortsBackNumberFontSize] = useState(100);
  const [shortsBackNumberLetterSpacing, setShortsBackNumberLetterSpacing] = useState(0);

  // Multi-stop gradient
  const [useBaseGrad, setUseBaseGrad] = useState(false);
  const [gradStops, setGradStops] = useState([
    makeStop("#1e293b", 0.0),
    makeStop("#0ea5e9", 0.5),
    makeStop("#22c55e", 1.0),
  ]);
  const [baseGradAngleDeg, setBaseGradAngleDeg] = useState(90);

  // Per-part tints
  const [tintFront, setTintFront] = useState("#A8B64D");
  const [tintBack, setTintBack] = useState("#A8B64D");
  const [tintLArmStripe, setTintLArmStripe] = useState("#A8B64D");
  const [tintRArmStripe, setTintRArmStripe] = useState("#A8B64D");
  const [tintLShoulderF, setTintLShoulderF] = useState("#1E1D1E");
  const [tintRShoulderF, setTintRShoulderF] = useState("#1E1D1E");
  const [tintLShoulderB, setTintLShoulderB] = useState("#1E1D1E");
  const [tintRShoulderB, setTintRShoulderB] = useState("#1E1D1E");
  const [tintNeck, setTintNeck] = useState("#A8B64D");
  const [tintLSleeve, setTintLSleeve] = useState("#1E1D1E");
  const [tintRSleeve, setTintRSleeve] = useState("#1E1D1E");
  const [tintShorts, setTintShorts] = useState("#A8B64D");
  const [baseColor, setBaseColor] = useState("#A8B64D");

  // Design + neck style + kit name tabs
  const [designTab, setDesignTab] = useState("Designs");
  const [selectedNeckStyle, setSelectedNeckStyle] = useState(NECK_STYLES[0]);
  const [selectedKit, setSelectedKit] = useState(KIT_NAMES[0]);

  // Camera
  const [autoRotate, setAutoRotate] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const controlsRef = useRef();

  // Color preservation state
  const [originalColors, setOriginalColors] = useState({
    tintFront: "#c5c7ce",
    tintBack: "#c5c7ce", 
    tintLArmStripe: "#c5c7ce",
    tintRArmStripe: "#c5c7ce",
    tintLShoulderF: "#003E9A",
    tintRShoulderF: "#003E9A",
    tintLShoulderB: "#003E9A",
    tintRShoulderB: "#003E9A",
    tintNeck: "#003E9A",
    tintLSleeve: "#003E9A",
    tintRSleeve: "#003E9A",
    tintShorts: "#00359B"
  });

  // ---------- 360 Snapshot Functions ----------
  const takeSnapshot = () => {
    const canvas = document.querySelector('canvas');
    if (!canvas) return null;
    
    try {
      const gl = canvas.getContext('webgl2') || canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      
      if (gl) {
        gl.flush();
      }
      
      const originalWidth = canvas.width;
      const originalHeight = canvas.height;
      
      const tempCanvas = document.createElement('canvas');
      const tempCtx = tempCanvas.getContext('2d');
      
      tempCanvas.width = originalWidth * 2;
      tempCanvas.height = originalHeight * 2;
      
      tempCtx.fillStyle = '#ffffff17';
      tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
      
      tempCtx.drawImage(
        canvas, 
        0, 0, originalWidth, originalHeight,
        0, 0, tempCanvas.width, tempCanvas.height
      );
      
      return tempCanvas.toDataURL('image/png', 1.0);
    } catch (error) {
      console.error('Snapshot error:', error);
      
      try {
        return canvas.toDataURL('image/png');
      } catch (fallbackError) {
        console.error('Fallback snapshot error:', fallbackError);
        return null;
      }
    }
  };

  const take360Snapshots = async () => {
    if (!controlsRef.current) {
      console.error('Controls not available');
      return;
    }
    
    setIsTakingSnapshots(true);
    const newSnapshots = [];
    const steps = 12;
    
    const originalAutoRotate = autoRotate;
    setAutoRotate(false);
    
    await new Promise(resolve => setTimeout(resolve, 200));
    
    try {
      for (let i = 0; i < steps; i++) {
        const angle = (i / steps) * Math.PI * 2;
        controlsRef.current.setAzimuthalAngle(angle);
        
        await new Promise(resolve => {
          requestAnimationFrame(() => {
            requestAnimationFrame(async () => {
              await new Promise(r => setTimeout(r, 150));
              
              const snapshot = takeSnapshot();
              if (snapshot) {
                newSnapshots.push({
                  id: `snap-${i}-${Date.now()}`,
                  data: snapshot,
                  angle: i * 30
                });
                console.log(`Snapshot ${i + 1} taken at ${i * 30}°`);
              } else {
                console.warn(`Failed to take snapshot ${i + 1}`);
              }
              
              resolve();
            });
          });
        });
      }
      
      if (newSnapshots.length > 0) {
        setSnapshots(newSnapshots);
        console.log(`Successfully captured ${newSnapshots.length} snapshots`);
      } else {
        console.warn('No snapshots were captured');
      }
      
    } catch (error) {
      console.error('Error during 360 snapshot capture:', error);
    } finally {
      setAutoRotate(originalAutoRotate);
      setIsTakingSnapshots(false);
    }
  };

  const clearSnapshots = () => {
    setSnapshots([]);
  };

  const handleGradientToggle = (checked) => {
    if (checked) {
      setOriginalColors({
        tintFront,
        tintBack,
        tintLArmStripe,
        tintRArmStripe,
        tintLShoulderF,
        tintRShoulderF,
        tintLShoulderB,
        tintRShoulderB,
        tintNeck,
        tintLSleeve,
        tintRSleeve,
        tintShorts
      });
      
      setTintFront("#ffffff");
      setTintBack("#ffffff");
      setTintLArmStripe("#ffffff");
      setTintRArmStripe("#ffffff");
      setTintLShoulderF("#ffffff");
      setTintRShoulderF("#ffffff");
      setTintLShoulderB("#ffffff");
      setTintRShoulderB("#ffffff");
      setTintNeck("#ffffff");
      setTintLSleeve("#ffffff");
      setTintRSleeve("#ffffff");
      setTintShorts("#ffffff");
    } else {
      setTintFront(originalColors.tintFront);
      setTintBack(originalColors.tintBack);
      setTintLArmStripe(originalColors.tintLArmStripe);
      setTintRArmStripe(originalColors.tintRArmStripe);
      setTintLShoulderF(originalColors.tintLShoulderF);
      setTintRShoulderF(originalColors.tintRShoulderF);
      setTintLShoulderB(originalColors.tintLShoulderB);
      setTintRShoulderB(originalColors.tintRShoulderB);
      setTintNeck(originalColors.tintNeck);
      setTintLSleeve(originalColors.tintLSleeve);
      setTintRSleeve(originalColors.tintRSleeve);
      setTintShorts(originalColors.tintShorts);
    }
    
    setUseBaseGrad(checked);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSidebarOpen(false);
    const editingTabs = [
      "Color",
      "FrontPattern",
      "UploadFrontPattern",
      "BackPattern", 
      "UploadBackPattern",
      "Gradient",
      "Logo",
      "Text",
      "Name",
      "Number",
      "Snapshots",
    ];
    const now = editingTabs.includes(tab);
    setIsEditing(now);
    setAutoRotate(!now);
    
    if (tab !== "Logo") {
      setSelectedLogoId(null);
    }
  };

  useEffect(() => {
    if (!isEditing) setAutoRotate(true);
  }, [isEditing]);

  const addStop = () => {
    if (gradStops.length >= 8) return;
    const last = [...gradStops].sort((a, b) => a.pos - b.pos).at(-1);
    const pos = Math.min(1, Math.max(0, (last?.pos ?? 1) - 0.1));
    setGradStops((prev) => [...prev, makeStop("#ffffff", pos)]);
  };
  const removeStop = (id) => setGradStops((prev) => prev.filter((s) => s.id !== id));
  const updateStopColor = (id, color) =>
    setGradStops((prev) => prev.map((s) => (s.id === id ? { ...s, color } : s)));
  const updateStopPos = (id, pos) =>
    setGradStops((prev) =>
      prev.map((s) =>
        s.id === id ? { ...s, pos: Math.max(0, Math.min(1, pos)) } : s
      )
    );
  const sortedStops = useMemo(() => [...gradStops].sort((a, b) => a.pos - b.pos), [gradStops]);

  // ----------- RENDER FUNCTIONS -----------

  const renderColorDrawer = () => (
    <div className="color-drawer" style={{ width: "29rem", border: "1px solid white" }}>
        <h4>Colors</h4>
      <div className="grid2">
        <label>Shirt Front</label>
        <input
          type="color"
          value={tintFront}
          onChange={(e) => setTintFront(e.target.value)}
        />
        <label>Shirt Back</label>
        <input type="color" value={tintBack} onChange={(e) => setTintBack(e.target.value)} />
        <label>Left Arm Stripe</label>
        <input
          type="color"
          value={tintLArmStripe}
          onChange={(e) => setTintLArmStripe(e.target.value)}
        />
        <label>Right Arm Stripe</label>
        <input
          type="color"
          value={tintRArmStripe}
          onChange={(e) => setTintRArmStripe(e.target.value)}
        />
        <label>Left Sleeve</label>
        <input
          type="color"
          value={tintLShoulderF}
          onChange={(e) => setTintLShoulderF(e.target.value)}
        />
        <label>Right Sleeve</label>
        <input
          type="color"
          value={tintRShoulderF}
          onChange={(e) => setTintRShoulderF(e.target.value)}
        />
        {/* <label>L Shoulder Back</label>
        <input
          type="color"
          value={tintLShoulderB}
          onChange={(e) => setTintLShoulderB(e.target.value)}
        />
        <label>R Shoulder Back</label>
        <input
          type="color"
          value={tintRShoulderB}
          onChange={(e) => setTintRShoulderB(e.target.value)}
        /> */}
        <label>Neck / Collar</label>
        {/* <input type="color" value={tintNeck} onChange={(e) => setTintNeck(e.target.value)} />
        <label>Left Sleeve</label> */}
        {/* <input type="color" value={tintLSleeve} onChange={(e) => setTintLSleeve(e.target.value)} />
        <label>Right Sleeve</label> */}
        <input type="color" value={tintRSleeve} onChange={(e) => setTintRSleeve(e.target.value)} />
        <label>Shorts</label>
        <input
          type="color"
          value={tintShorts}
          onChange={(e) => setTintShorts(e.target.value)}
        />
      </div>
    </div>
  );

  // ----------- FRONT STATIC PATTERN TAB -----------
  const renderFrontPatternTab = () => (
    <div className="designs">
      <div className="color-drawer">
        <h4>Front Static Patterns</h4>
        <div className="grid-cards">
          {PATTERNS.map((p) => (
            <button
              key={p.id}
              className={`card ${
                !!selectedPattern && selectedPattern.id === p.id
                  ? "sel"
                  : ""
              }`}
              onClick={() => {
                setSelectedPattern(p);
                setShowPattern(true);
                // Clear uploaded pattern when selecting static pattern
                if (uploadedPattern) {
                  clearUploadedPattern();
                }
              }}
              title={p.name}
            >
              <img src={p.img} alt={p.name} />
            </button>
          ))}
        </div>
      </div>

      {/* Front Pattern Toggle */}
      <div className="color-drawer" style={{ marginTop: 12 }}>
        <h4>Front Pattern Placement</h4>
        <div className="grid2">
          <label>Show Pattern on Front</label>
          <input
            type="checkbox"
            checked={showPatternOnFront}
            onChange={(e) => setShowPatternOnFront(e.target.checked)}
          />
        </div>
      </div>

      {/* Front Static Pattern Controls */}
      {!uploadedPattern && (
        <div className="color-drawer" style={{ marginTop: 12 }}>
          <h4>Front Static Pattern Controls</h4>
          <div className="grid2">
            <label>X-Axis</label>
            <input
              type="range"
              min={-1}
              max={2}
              step="0.01"
              value={staticPatternPosition.x}
              onChange={(e) =>
                setStaticPatternPosition((p) => ({
                  ...p,
                  x: parseFloat(e.target.value),
                }))
              }
            />
            <label>Y-Axis</label>
            <input
              type="range"
              min={-1}
              max={2}
              step="0.01"
              value={staticPatternPosition.y}
              onChange={(e) =>
                setStaticPatternPosition((p) => ({
                  ...p,
                  y: parseFloat(e.target.value),
                }))
              }
            />
            <label>Scale</label>
            <input
              type="range"
              min="0.1"
              max="3"
              step="0.01"
              value={staticPatternScale}
              onChange={(e) =>
                setStaticPatternScale(parseFloat(e.target.value))
              }
            />
            <label>Rotation</label>
            <input
              type="range"
              min="-3.14"
              max="3.14"
              step="0.01"
              value={staticPatternRotation}
              onChange={(e) =>
                setStaticPatternRotation(parseFloat(e.target.value))
              }
            />
            <label>Strength</label>
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={patternStrength}
              onChange={(e) =>
                setPatternStrength(parseFloat(e.target.value))
              }
            />
            <label>Pattern Color</label>
            <input
              type="color"
              value={patternColor}
              onChange={(e) => setPatternColor(e.target.value)}
            />
          </div>
        </div>
      )}
    </div>
  );

  // ----------- FRONT UPLOADED PATTERN TAB -----------
  const renderUploadFrontPatternTab = () => (
    <div className="designs">
      {/* Upload Front Pattern Section */}
      <PatternUploadSection 
        title="Upload Front Pattern"
        onPatternUpload={handlePatternUpload}
        uploadedPattern={uploadedPattern}
        onClearPattern={clearUploadedPattern}
        patternPosition={patternPosition}
        onPatternPositionChange={setPatternPosition}
        patternScale={patternScale}
        onPatternScaleChange={setPatternScale}
        patternRotation={patternRotation}
        onPatternRotationChange={setPatternRotation}
        patternStrength={patternStrength}
        onPatternStrengthChange={setPatternStrength}
        showPattern={showPattern}
        onShowPatternChange={setShowPattern}
        showPatternOnPart={showPatternOnFront}
        onShowPatternOnPartChange={setShowPatternOnFront}
        partName="Front"
      />
    </div>
  );

  // ----------- BACK STATIC PATTERN TAB -----------
  const renderBackPatternTab = () => (
    <div className="designs">
      <div className="color-drawer">
        <h4>Back Static Patterns</h4>
        <div className="grid-cards">
          {PATTERNS.map((p) => (
            <button
              key={p.id}
              className={`card ${
                !!selectedBackPattern && selectedBackPattern.id === p.id
                  ? "sel"
                  : ""
              }`}
              onClick={() => {
                setSelectedBackPattern(p);
                setShowBackPattern(true);
                // Clear uploaded pattern when selecting static pattern
                if (uploadedBackPattern) {
                  clearUploadedBackPattern();
                }
              }}
              title={p.name}
            >
              <img src={p.img} alt={p.name} />
            </button>
          ))}
        </div>
      </div>

      {/* Back Pattern Toggle */}
      <div className="color-drawer" style={{ marginTop: 12 }}>
        <h4>Back Pattern Placement</h4>
        <div className="grid2">
          <label>Show Pattern on Back</label>
          <input
            type="checkbox"
            checked={showPatternOnBack}
            onChange={(e) => setShowPatternOnBack(e.target.checked)}
          />
        </div>
      </div>

      {/* Back Static Pattern Controls */}
      {!uploadedBackPattern && (
        <div className="color-drawer" style={{ marginTop: 12 }}>
          <h4>Back Static Pattern Controls</h4>
          <div className="grid2">
            <label>X-Axis</label>
            <input
              type="range"
              min={-1}
              max={2}
              step="0.01"
              value={staticBackPatternPosition.x}
              onChange={(e) =>
                setStaticBackPatternPosition((p) => ({
                  ...p,
                  x: parseFloat(e.target.value),
                }))
              }
            />
            <label>Y-Axis</label>
            <input
              type="range"
              min={-1}
              max={2}
              step="0.01"
              value={staticBackPatternPosition.y}
              onChange={(e) =>
                setStaticBackPatternPosition((p) => ({
                  ...p,
                  y: parseFloat(e.target.value),
                }))
              }
            />
            <label>Scale</label>
            <input
              type="range"
              min="0.1"
              max="3"
              step="0.01"
              value={staticBackPatternScale}
              onChange={(e) =>
                setStaticBackPatternScale(parseFloat(e.target.value))
              }
            />
            <label>Rotation</label>
            <input
              type="range"
              min="-3.14"
              max="3.14"
              step="0.01"
              value={staticBackPatternRotation}
              onChange={(e) =>
                setStaticBackPatternRotation(parseFloat(e.target.value))
              }
            />
            <label>Strength</label>
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={backPatternStrength}
              onChange={(e) =>
                setBackPatternStrength(parseFloat(e.target.value))
              }
            />
            <label>Pattern Color</label>
            <input
              type="color"
              value={backPatternColor}
              onChange={(e) => setBackPatternColor(e.target.value)}
            />
          </div>
        </div>
      )}
    </div>
  );

  // ----------- BACK UPLOADED PATTERN TAB -----------
  const renderUploadBackPatternTab = () => (
    <div className="designs">
      {/* Upload Back Pattern Section */}
      <PatternUploadSection 
        title="Upload Back Pattern"
        onPatternUpload={handleBackPatternUpload}
        uploadedPattern={uploadedBackPattern}
        onClearPattern={clearUploadedBackPattern}
        patternPosition={backPatternPosition}
        onPatternPositionChange={setBackPatternPosition}
        patternScale={backPatternScale}
        onPatternScaleChange={setBackPatternScale}
        patternRotation={backPatternRotation}
        onPatternRotationChange={setBackPatternRotation}
        patternStrength={backPatternStrength}
        onPatternStrengthChange={setBackPatternStrength}
        showPattern={showBackPattern}
        onShowPatternChange={setShowBackPattern}
        showPatternOnPart={showPatternOnBack}
        onShowPatternOnPartChange={setShowPatternOnBack}
        partName="Back"
      />
    </div>
  );

  // ----------- LOGO TAB -----------
  const renderLogoTab = () => (
    <div className="designs">
      <LogoUploadSection
        onLogoUpload={handleLogoUpload}
        logoLayers={logoLayers}
        selectedLogoId={selectedLogoId}
        onSelectLogo={setSelectedLogoId}
        onRemoveLogo={removeLogo}
        onUpdateLogo={updateLogo}
        onDuplicateLogo={duplicateLogo}
        onMoveLogo={moveLogo}
        onReplaceLogo={handleReplaceLogo}
        onAddLogoToPart={handleAddLogoToPart}
      />
    </div>
  );

  // ----------- TEXT TAB -----------
  const renderTextTab = () => (
    <div className="designs">
      <div className="color-drawer">
        <h4>Front Text 1</h4>
        <div className="grid2">
          <label>Show Text</label>
          <input
            type="checkbox"
            checked={showText}
            onChange={(e) => setShowText(e.target.checked)}
          />
          <label>Text Content</label>
          <input
            type="text"
            value={textContent}
            onChange={(e) => setTextContent(e.target.value)}
            placeholder="Enter text..."
          />
          <label>Text Color</label>
          <input
            type="color"
            value={textColor}
            onChange={(e) => setTextColor(e.target.value)}
          />
          <label>Stroke Color</label>
          <input
            type="color"
            value={textStroke}
            onChange={(e) => setTextStroke(e.target.value)}
          />
          <label>Stroke Width</label>
          <input
            type="range"
            min="0"
            max="6"
            step="0.5"
            value={textStrokeW}
            onChange={(e) => setTextStrokeW(parseFloat(e.target.value))}
          />
          <label>Font Size</label>
          <input
            type="number"
            value={textFontSize}
            onChange={(e) => setTextFontSize(parseInt(e.target.value))}
          />
          <label>Letter Spacing</label>
          <input
            type="number"
            value={textLetterSpacing}
            onChange={(e) => setTextLetterSpacing(parseInt(e.target.value))}
          />
          <label>X Position</label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={textPosition.x}
            onChange={(e) => setTextPosition(p => ({...p, x: parseFloat(e.target.value)}))}
          />
          <label>Y Position</label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={textPosition.y}
            onChange={(e) => setTextPosition(p => ({...p, y: parseFloat(e.target.value)}))}
          />
          <label>Scale</label>
          <input
            type="range"
            min="0.1"
            max="1"
            step="0.01"
            value={textScale}
            onChange={(e) => setTextScale(parseFloat(e.target.value))}
          />
        </div>
      </div>

      
    </div>
  );

  // ----------- NAME TAB -----------
  const renderNameTab = () => (
    <div className="designs">
      <div className="color-drawer">
        <h4>Back Name 1</h4>
        <div className="grid2">
          <label>Show Name</label>
          <input
            type="checkbox"
            checked={showBackText}
            onChange={(e) => setShowBackText(e.target.checked)}
          />
          <label>Name Content</label>
          <input
            type="text"
            value={backTextContent}
            onChange={(e) => setBackTextContent(e.target.value)}
            placeholder="Enter name..."
          />
          <label>Text Color</label>
          <input
            type="color"
            value={backTextColor}
            onChange={(e) => setBackTextColor(e.target.value)}
          />
          <label>Stroke Color</label>
          <input
            type="color"
            value={backTextStroke}
            onChange={(e) => setBackTextStroke(e.target.value)}
          />
          <label>Stroke Width</label>
          <input
            type="range"
            min="0"
            max="6"
            step="0.5"
            value={backTextStrokeW}
            onChange={(e) => setBackTextStrokeW(parseFloat(e.target.value))}
          />
          <label>Font Size</label>
          <input
            type="number"
            value={backTextFontSize}
            onChange={(e) => setBackTextFontSize(parseInt(e.target.value))}
          />
          <label>Letter Spacing</label>
          <input
            type="number"
            value={backTextLetterSpacing}
            onChange={(e) => setBackTextLetterSpacing(parseInt(e.target.value))}
          />
          <label>X Position</label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={backTextPosition.x}
            onChange={(e) => setBackTextPosition(p => ({...p, x: parseFloat(e.target.value)}))}
          />
          <label>Y Position</label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={backTextPosition.y}
            onChange={(e) => setBackTextPosition(p => ({...p, y: parseFloat(e.target.value)}))}
          />
          <label>Scale</label>
          <input
            type="range"
            min="0.1"
            max="1"
            step="0.01"
            value={backTextScale}
            onChange={(e) => setBackTextScale(parseFloat(e.target.value))}
          />
        </div>
      </div>

     
    </div>
  );

  // ----------- NUMBER TAB -----------
  const renderNumberTab = () => (
    <div className="designs">
      <div className="color-drawer">
        <h4>Front Number</h4>
        <div className="grid2">
          <label>Show Number</label>
          <input
            type="checkbox"
            checked={showFrontNumber}
            onChange={(e) => setShowFrontNumber(e.target.checked)}
          />
          <label>Number</label>
          <input
            type="text"
            value={frontNumberValue}
            onChange={(e) => setFrontNumberValue(e.target.value)}
            placeholder="Enter number..."
            maxLength={2}
          />
          <label>Number Color</label>
          <input
            type="color"
            value={frontNumberColor}
            onChange={(e) => setFrontNumberColor(e.target.value)}
          />
          <label>Stroke Color</label>
          <input
            type="color"
            value={frontNumberStroke}
            onChange={(e) => setFrontNumberStroke(e.target.value)}
          />
          <label>Stroke Width</label>
          <input
            type="range"
            min="0"
            max="6"
            step="0.5"
            value={frontNumberStrokeW}
            onChange={(e) => setFrontNumberStrokeW(parseFloat(e.target.value))}
          />
          <label>Font Size</label>
          <input
            type="number"
            value={frontNumberFontSize}
            onChange={(e) => setFrontNumberFontSize(parseInt(e.target.value))}
          />
          <label>Letter Spacing</label>
          <input
            type="number"
            value={frontNumberLetterSpacing}
            onChange={(e) => setFrontNumberLetterSpacing(parseInt(e.target.value))}
          />
          <label>X Position</label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={frontNumberPosition.x}
            onChange={(e) => setFrontNumberPosition(p => ({...p, x: parseFloat(e.target.value)}))}
          />
          <label>Y Position</label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={frontNumberPosition.y}
            onChange={(e) => setFrontNumberPosition(p => ({...p, y: parseFloat(e.target.value)}))}
          />
          <label>Scale X</label>
          <input
            type="range"
            min="0.1"
            max="1"
            step="0.01"
            value={frontNumberScale.x}
            onChange={(e) => setFrontNumberScale(p => ({...p, x: parseFloat(e.target.value)}))}
          />
          <label>Scale Y</label>
          <input
            type="range"
            min="0.1"
            max="1"
            step="0.01"
            value={frontNumberScale.y}
            onChange={(e) => setFrontNumberScale(p => ({...p, y: parseFloat(e.target.value)}))}
          />
        </div>
      </div>

      <div className="color-drawer" style={{ marginTop: 12 }}>
        <h4>Back Number</h4>
        <div className="grid2">
          <label>Show Number</label>
          <input
            type="checkbox"
            checked={showBackNumber}
            onChange={(e) => setShowBackNumber(e.target.checked)}
          />
          <label>Number</label>
          <input
            type="text"
            value={backNumberValue}
            onChange={(e) => setBackNumberValue(e.target.value)}
            placeholder="Enter number..."
            maxLength={2}
          />
          <label>Number Color</label>
          <input
            type="color"
            value={backNumberColor}
            onChange={(e) => setBackNumberColor(e.target.value)}
          />
          <label>Stroke Color</label>
          <input
            type="color"
            value={backNumberStroke}
            onChange={(e) => setBackNumberStroke(e.target.value)}
          />
          <label>Stroke Width</label>
          <input
            type="range"
            min="0"
            max="6"
            step="0.5"
            value={backNumberStrokeW}
            onChange={(e) => setBackNumberStrokeW(parseFloat(e.target.value))}
          />
          <label>Font Size</label>
          <input
            type="number"
            value={backNumberFontSize}
            onChange={(e) => setBackNumberFontSize(parseInt(e.target.value))}
          />
          <label>Letter Spacing</label>
          <input
            type="number"
            value={backNumberLetterSpacing}
            onChange={(e) => setBackNumberLetterSpacing(parseInt(e.target.value))}
          />
          <label>X Position</label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={backNumberPosition.x}
            onChange={(e) => setBackNumberPosition(p => ({...p, x: parseFloat(e.target.value)}))}
          />
          <label>Y Position</label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={backNumberPosition.y}
            onChange={(e) => setBackNumberPosition(p => ({...p, y: parseFloat(e.target.value)}))}
          />
          <label>Scale X</label>
          <input
            type="range"
            min="0.1"
            max="1"
            step="0.01"
            value={backNumberScale.x}
            onChange={(e) => setBackNumberScale(p => ({...p, x: parseFloat(e.target.value)}))}
          />
          <label>Scale Y</label>
          <input
            type="range"
            min="0.1"
            max="1"
            step="0.01"
            value={backNumberScale.y}
            onChange={(e) => setBackNumberScale(p => ({...p, y: parseFloat(e.target.value)}))}
          />
        </div>
      </div>

      <div className="color-drawer" style={{ marginTop: 12 }}>
        <h4>Shorts Front Number</h4>
        <div className="grid2">
          <label>Show Number</label>
          <input
            type="checkbox"
            checked={showShortsFrontNumber}
            onChange={(e) => setShowShortsFrontNumber(e.target.checked)}
          />
          <label>Number</label>
          <input
            type="text"
            value={shortsFrontNumberValue}
            onChange={(e) => setShortsFrontNumberValue(e.target.value)}
            placeholder="Enter number..."
            maxLength={2}
          />
          <label>Number Color</label>
          <input
            type="color"
            value={shortsFrontNumberColor}
            onChange={(e) => setShortsFrontNumberColor(e.target.value)}
          />
          <label>Stroke Color</label>
          <input
            type="color"
            value={shortsFrontNumberStroke}
            onChange={(e) => setShortsFrontNumberStroke(e.target.value)}
          />
          <label>Stroke Width</label>
          <input
            type="range"
            min="0"
            max="6"
            step="0.5"
            value={shortsFrontNumberStrokeW}
            onChange={(e) => setShortsFrontNumberStrokeW(parseFloat(e.target.value))}
          />
          <label>Font Size</label>
          <input
            type="number"
            value={shortsFrontNumberFontSize}
            onChange={(e) => setShortsFrontNumberFontSize(parseInt(e.target.value))}
          />
          <label>Letter Spacing</label>
          <input
            type="number"
            value={shortsFrontNumberLetterSpacing}
            onChange={(e) => setShortsFrontNumberLetterSpacing(parseInt(e.target.value))}
          />
          <label>X Position</label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={shortsFrontNumberPosition.x}
            onChange={(e) => setShortsFrontNumberPosition(p => ({...p, x: parseFloat(e.target.value)}))}
          />
          <label>Y Position</label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={shortsFrontNumberPosition.y}
            onChange={(e) => setShortsFrontNumberPosition(p => ({...p, y: parseFloat(e.target.value)}))}
          />
          <label>Scale X</label>
          <input
            type="range"
            min="0.1"
            max="1"
            step="0.01"
            value={shortsFrontNumberScale.x}
            onChange={(e) => setShortsFrontNumberScale(p => ({...p, x: parseFloat(e.target.value)}))}
          />
          <label>Scale Y</label>
          <input
            type="range"
            min="0.1"
            max="1"
            step="0.01"
            value={shortsFrontNumberScale.y}
            onChange={(e) => setShortsFrontNumberScale(p => ({...p, y: parseFloat(e.target.value)}))}
          />
        </div>
      </div>

    </div>
  );

  // ----------- SNAPSHOTS TAB -----------
  const renderSnapshotsTab = () => (
    <div className="designs">
      <SnapshotSection
        snapshots={snapshots}
        onTakeSnapshots={take360Snapshots}
        onClearSnapshots={clearSnapshots}
        isTakingSnapshots={isTakingSnapshots}
      />
    </div>
  );

  return (
    <div className={`layout ${sidebarOpen ? "sidebar-open" : ""}`}>
      {/* LEXA-STYLE SIDEBAR */}
      <aside className="lexa-sidebar">
        <div className="lexa-brand">
          <span className="brand-mark">CS</span>
          <div className="brand-text">
            <strong>Connect Sports</strong>
            <small>Full Sleeves Configurator</small>
          </div>
          <button
            className="lexa-hamburger"
            onClick={() => setSidebarOpen((v) => !v)}
            aria-label="Toggle Sidebar"
            title="Toggle Sidebar"
          >
            ☰
          </button>
        </div>

   <nav className="lexa-nav">
  {[
      // ⭐ NEW TAB ON TOP
      {
        key: "Categories",
        icon: "📂",
      },

      // Existing tabs
      {
        key: "Design",
        icon: "🎨",
      },
      {
        key: "Color",
        icon: "🎨",
      },
      {
        key: "FrontPattern",
        icon: "🔲",
      },
      {
        key: "UploadFrontPattern",
        icon: "📁",
      },
      {
        key: "BackPattern",
        icon: "🔲",
      },
      {
        key: "UploadBackPattern",
        icon: "📁",
      },
      {
        key: "Gradient",
        icon: "🌈",
      },
      {
        key: "Number",
        icon: "🔢",
      },
      {
        key: "Name",
        icon: "👤",
      },
      {
        key: "Text",
        icon: "📝",
      },
      {
        key: "Logo",
        icon: "⭐",
      },
      {
        key: "Snapshots",
        icon: "📸",
      },
    ].map((item) => (
      <button
        key={item.key}
        className={`lexa-link ${activeTab === item.key ? "active" : ''}`}
        onClick={() => handleTabChange(item.key)}
        title={item.key}
      >
        <span className="lexa-icon">{item.icon}</span>
        <span className="lexa-label">{item.key}</span>
      </button>
    ))}
</nav>

      </aside>

      {/* MAIN */}
      <div className="lexa-main">
        <header className="lexa-topbar">
          <div className="top-left">
            <button
              className="top-hamburger"
              onClick={() => setSidebarOpen((v) => !v)}
              aria-label="Toggle Sidebar"
              title="Toggle Sidebar"
            >
              ☰
            </button>
            <h2 className="top-title">{activeTab}</h2>
          </div>
          <div className="top-actions">
            <button
              className="top-btn"
              onClick={() => setAutoRotate(!autoRotate)}
              title={autoRotate ? "Pause rotation" : "Start rotation"}
            >
              {autoRotate ? "⏸️" : "▶️"}
            </button>
          </div>
        </header>

        <div className="cfg-wrap">
          <div className="cfg-body">
            {/* LEFT PANEL */}
            <section className="lexa-panel">
              {activeTab === "Categories" && (
  <div className="designs">

    <h3 style={{ marginBottom: "12px" }}>Select Kit Category</h3>

    <div className="grid-cards">

      <Link to="/colar" style={{ textDecoration: "none" }}>
        <button className="card">
          <img src="/assets/images/soccer.png" alt="Soccer Kit" />
          <div style={{ padding: 8, color: "#fff",textAlign: "center" }}>Soccer Kits</div>
        </button>
      </Link>

      <Link to="/cricket-2" style={{ textDecoration: "none" }}>
        <button className="card">
          <img src="/assets/images/cricket.png" alt="Cricket Kit" />
          <div style={{ padding: 8, color: "#fff",textAlign: "center" }}>Cricket Kits</div>
        </button>
      </Link>

      <Link to="/basket" style={{ textDecoration: "none" }}>
        <button className="card">
          <img src="/assets/images/basketball.png" alt="Basketball Kit" />
          <div style={{ padding: 8, color: "#fff", textAlign: "center" }}>Basketball Kits</div>
        </button>
      </Link>
           <Link to="/goalkeeper-2" style={{ textDecoration: "none" }}>
        <button className="card">
          <img src="/assets/images/goalkeeper.png" alt="Basketball Kit" />
          <div style={{ padding: 8, color: "#fff",textAlign: "center" }}>Goalkeeper Kits</div>
        </button>
      </Link>

    </div>
  </div>
)}

              {activeTab === "Design" ? (
                <div className="designs">
                  <div className="designs-head">
                    <button
                      className={`seg ${designTab === "Designs" ? "active" : ""}`}
                      onClick={() => setDesignTab("Designs")}
                    >
                      Designs
                    </button>
                    <button
                      className={`seg ${designTab === "Neck Style Options" ? "active" : ""}`}
                      onClick={() => setDesignTab("Neck Style Options")}
                    >
                      Style Options
                    </button>
                    {/* <button
                      className={`seg ${designTab === "Kit Names" ? "active" : ""}`}
                      onClick={() => setDesignTab("Kit Names")}
                    >
                      Kit Names
                    </button> */}
                  </div>

{designTab === "Designs" && (
  <>
    <div className="grid-cards">
      {ONLINE_DESIGNS.map((d) => (
        <Link
          key={d.id}
          to={d.path}
          style={{ textDecoration: "none" }}
          onClick={() => setSelected(d)}
        >
          <button
            className={`card ${selected?.id === d.id ? "sel" : ""}`}
            title={d.name}
          >
            <img src={d.img} alt={d.name} />
          </button>
        </Link>
      ))}
    </div>

    <button className="add-product">+ Add product</button>
  </>
)}

                  {designTab === "Neck Style Options" && (
                    <>
                      {/* Neck Styles Section */}
                      <div className="color-drawer" style={{ marginBottom: '12px' }}>
                        <h4>Neck Styles</h4>
                        <div className="grid-cards">
                          {NECK_STYLES.map((neck) => (
                            <Link
                              key={neck.id}
                              to={neck.path}
                              style={{ textDecoration: 'none' }}
                            >
                              <button
                                className={`card ${selectedNeckStyle.id === neck.id ? "sel" : ""}`}
                                onClick={() => setSelectedNeckStyle(neck)}
                                title={neck.name}
                                style={{
                                  width: '100%',
                                  border: 'none',
                                  background: 'transparent',
                                  cursor: 'pointer',
                                  padding: 0,
                                  color: 'white'
                                }}
                              >
                                <img src={neck.img} alt={neck.name} />
                                <div
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                    fontSize: "12px",
                                  }}
                                >
                                  {neck.name}
                                </div>
                              </button>
                            </Link>
                          ))}
                        </div>
                      </div>

                      {/* Full Sleeves Section */}
                      <div className="color-drawer">
                        <h4>Full Sleeves Styles</h4>
                        <div className="grid-cards">
                          {FULL_SLEEVES_STYLES.map((sleeve) => (
                            <Link
                              key={sleeve.id}
                              to={sleeve.path}
                              style={{ textDecoration: 'none' }}
                            >
                              <button
                                className={`card ${selectedFullSleeve.id === sleeve.id ? "sel" : ""}`}
                                onClick={() => setSelectedFullSleeve(sleeve)}
                                title={sleeve.name}
                                style={{
                                  width: '100%',
                                  border: 'none',
                                  background: 'transparent',
                                  cursor: 'pointer',
                                  padding: 0,
                                  color: 'white'
                                }}
                              >
                                <img src={sleeve.img} alt={sleeve.name} />
                                <div
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                    fontSize: "12px",
                                  }}
                                >
                                  {sleeve.name}
                                </div>
                              </button>
                            </Link>
                          ))}
                        </div>
                      </div>

                      {/* Selection Summary */}
                      <div
                        style={{
                          marginTop: "12px",
                          padding: "12px",
                          background: "rgba(255,255,255,0.05)",
                          borderRadius: "8px",
                        }}
                      >
                        <h4 style={{ margin: "0 0 8px 0" }}>Selected Styles</h4>
                        <p style={{ margin: 0, fontSize: "14px" }}>
                          <strong>Neck:</strong> {selectedNeckStyle.name} |{" "}
                          <strong>Sleeves:</strong> {selectedFullSleeve.name}
                        </p>
                        <p style={{ margin: "8px 0 0 0", fontSize: "12px", opacity: 0.8 }}>
                          <strong>Click on any style to navigate to its page.</strong>
                        </p>
                      </div>
                    </>
                  )}

                  {designTab === "Kit Names" && (
                    <>
                      <div className="grid-cards">
                        {KIT_NAMES.map((kit) => (
                          <button
                            key={kit.id}
                            className={`card ${selectedKit.id === kit.id ? "sel" : ""}`}
                            onClick={() => setSelectedKit(kit)}
                            title={kit.name}
                          >
                            <img src={kit.img} alt={kit.name} />
                            <div
                              style={{
                                padding: "8px",
                                textAlign: "center",
                                fontSize: "12px",
                              }}
                            >
                              {kit.name}
                            </div>
                          </button>
                        ))}
                      </div>
                      <div
                        style={{
                          marginTop: "12px",
                          padding: "12px",
                          background: "rgba(255,255,255,0.05)",
                          borderRadius: "8px",
                        }}
                      >
                        <h4 style={{ margin: "0 0 8px 0" }}>Selected Kit Name</h4>
                        <p style={{ margin: 0, fontSize: "14px" }}>
                          <strong>{selectedKit.name}</strong> – You can use this kit name in your order
                          summary, PDFs, or cart.
                        </p>
                      </div>
                    </>
                  )}
                </div>
              ) : activeTab === "Color" ? (
                renderColorDrawer()
              ) : activeTab === "FrontPattern" ? (
                renderFrontPatternTab()
              ) : activeTab === "UploadFrontPattern" ? (
                renderUploadFrontPatternTab()
              ) : activeTab === "BackPattern" ? (
                renderBackPatternTab()
              ) : activeTab === "UploadBackPattern" ? (
                renderUploadBackPatternTab()
              ) : activeTab === "Gradient" ? (
                <div className="designs">
                  <div className="color-drawer">
                    <h4>Model Gradient</h4>
                    <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <input
                        type="checkbox"
                        checked={useBaseGrad}
                        onChange={(e) => handleGradientToggle(e.target.checked)}
                      />
                      Apply gradient on model (auto-reset colors)
                    </label>
                    <div className="grid2" style={{ marginTop: 8 }}>
                      <label>Angle (°)</label>
                      <input
                        type="number"
                        min="0"
                        max="360"
                        value={baseGradAngleDeg}
                        onChange={(e) =>
                          setBaseGradAngleDeg(parseFloat(e.target.value || "0"))
                        }
                      />
                    </div>
                    <div className="stops" style={{ marginTop: 12 }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: 6,
                        }}
                      >
                        <h5 style={{ margin: 0 }}>Color Stops</h5>
                        <button
                          type="button"
                          onClick={addStop}
                          disabled={gradStops.length >= 8}
                        >
                          + Add stop
                        </button>
                      </div>
                      {sortedStops.map((s, idx) => (
                        <div
                          key={s.id}
                          className="stop-row"
                          style={{
                            display: "grid",
                            gridTemplateColumns: "auto 120px 1fr auto",
                            gap: 8,
                            alignItems: "center",
                            marginBottom: 8,
                          }}
                        >
                          <span style={{ fontSize: 12 }}>#{idx + 1}</span>
                          <input
                            type="color"
                            value={s.color}
                            onChange={(e) =>
                              updateStopColor(s.id, e.target.value)
                            }
                          />
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <input
                              type="range"
                              min="0"
                              max="1"
                              step="0.01"
                              value={s.pos}
                              onChange={(e) =>
                                updateStopPos(s.id, parseFloat(e.target.value))
                              }
                              style={{ width: "100%" }}
                            />
                            <input
                              type="number"
                              min="0"
                              max="1"
                              step="0.01"
                              value={s.pos}
                              onChange={(e) =>
                                updateStopPos(
                                  s.id,
                                  parseFloat(e.target.value || "0")
                                )
                              }
                              style={{ width: 70 }}
                            />
                          </div>
                          <button
                            type="button"
                            onClick={() => removeStop(s.id)}
                            disabled={gradStops.length <= 1}
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : activeTab === "Text" ? (
                renderTextTab()
              ) : activeTab === "Name" ? (
                renderNameTab()
              ) : activeTab === "Number" ? (
                renderNumberTab()
              ) : activeTab === "Logo" ? (
                renderLogoTab()
              ) : activeTab === "Snapshots" ? (
                renderSnapshotsTab()
              ) : (
                <div className="placeholder">
                  <p>
                    Panel for <b>{activeTab}</b>
                  </p>
                </div>
              )}
            </section>

            {/* RIGHT (3D MODEL) */}
            <main className="cfg-stage">
              <div
                className="stage-inner"
                style={{
                  background: "#ffffff17",
                  borderRadius: "8px",
                  position: "relative",
                  overflow: "hidden",
                      height: "calc(100vh - 120px)"  // ⭐ Best dynamic solution

                   
                }}
              >
                <Canvas
             camera={{ position: [0, 0, 8.2], fov: 45 }}
                  gl={{
                    powerPreference: "high-performance",
                    antialias: false,
                    alpha: true,
                    preserveDrawingBuffer: true,
                  }}
                  style={{ background: "#ffffff17" }}
                >
                  <ambientLight intensity={0.6} />
                  <directionalLight position={[5, 5, 5]} intensity={1.2} />

                  <TexturedFullSleevesSoccerKit
                    baseColor="#ffffff"
                    useBaseGrad={useBaseGrad}
                    gradStops={sortedStops}
                    gradAngle={(baseGradAngleDeg * Math.PI) / 180}
                    patternUrl={uploadedPatternUrl || selectedPattern?.img}
                    showPattern={!!(showPattern && (uploadedPatternUrl || selectedPattern))}
                    patternColor={patternColor}
                    patternStrength={patternStrength}
                    isUploadedPattern={!!uploadedPatternUrl}
                    patternPosition={uploadedPatternUrl ? patternPosition : staticPatternPosition}
                    patternScale={uploadedPatternUrl ? patternScale : staticPatternScale}
                    patternRotation={uploadedPatternUrl ? patternRotation : staticPatternRotation}
                    showPatternOnFront={showPatternOnFront}
                    backPatternUrl={uploadedBackPatternUrl || selectedBackPattern?.img}
                    showBackPattern={false}
                    backPatternColor={backPatternColor}
                    backPatternStrength={backPatternStrength}
                    isUploadedBackPattern={!!uploadedBackPatternUrl}
                    backPatternPosition={uploadedBackPatternUrl ? backPatternPosition : staticBackPatternPosition}
                    backPatternScale={uploadedBackPatternUrl ? backPatternScale : staticBackPatternScale}
                    backPatternRotation={uploadedBackPatternUrl ? backPatternRotation : staticBackPatternRotation}
                    showPatternOnBack={false}
                    overlayFrontTex={overlayFrontTex}
                    overlayBackTex={overlayBackTex}
                    overlayLShoulderFTex={overlayLShoulderFTex}
                    overlayRShoulderFTex={overlayRShoulderFTex}
                    overlayShortsFrontTex={overlayShortsFrontTex}
                    overlayShortsBackTex={overlayShortsBackTex}
                    
                    // Text and number props - ALL INITIALLY HIDDEN/EMPTY
                    textContent={textContent}
                    showText={!!(showText && textContent)}
                    textColor={textColor}
                    textStroke={textStroke}
                    textStrokeW={clamp(textStrokeW, 0, 6)}
                    textPosition={[textPosition.x, textPosition.y]}
                    textScale={[textScale, textScale]}
                    textFontSize={textFontSize}
                    textLetterSpacing={textLetterSpacing}
                    
                    textContent2={textContent2}
                    showText2={!!(showText2 && textContent2)}
                    textColor2={textColor2}
                    textStroke2={textStroke2}
                    textStrokeW2={clamp(textStrokeW2, 0, 6)}
                    textPosition2={[textPosition2.x, textPosition2.y]}
                    textScale2={[textScale2, textScale2]}
                    textFontSize2={textFontSize2}
                    textLetterSpacing2={textLetterSpacing2}
                    
                    backTextContent={backTextContent}
                    showBackText={!!(showBackText && backTextContent)}
                    backTextColor={backTextColor}
                    backTextStroke={backTextStroke}
                    backTextStrokeW={clamp(backTextStrokeW, 0, 6)}
                    backTextPosition={[backTextPosition.x, backTextPosition.y]}
                    backTextScale={[backTextScale, backTextScale]}
                    backTextFontSize={backTextFontSize}
                    backTextLetterSpacing={backTextLetterSpacing}
                    
                    backTextContent2={backTextContent2}
                    showBackText2={!!(showBackText2 && backTextContent2)}
                    backTextColor2={backTextColor2}
                    backTextStroke2={backTextStroke2}
                    backTextStrokeW2={clamp(backTextStrokeW2, 0, 6)}
                    backTextPosition2={[backTextPosition2.x, backTextPosition2.y]}
                    backTextScale2={[backTextScale2, backTextScale2]}
                    backTextFontSize2={backTextFontSize2}
                    backTextLetterSpacing2={backTextLetterSpacing2}
                    
                    frontNumberValue={frontNumberValue}
                    showFrontNumber={!!(showFrontNumber && frontNumberValue)}
                    frontNumberColor={frontNumberColor}
                    frontNumberStroke={frontNumberStroke}
                    frontNumberStrokeW={clamp(frontNumberStrokeW, 0, 6)}
                    frontNumberPosition={[
                      frontNumberPosition.x,
                      frontNumberPosition.y,
                    ]}
                    frontNumberScale={[
                      frontNumberScale.x,
                      frontNumberScale.y,
                    ]}
                    frontNumberFontSize={frontNumberFontSize}
                    frontNumberLetterSpacing={frontNumberLetterSpacing}
                    
                    backNumberValue={backNumberValue}
                    showBackNumber={!!(showBackNumber && backNumberValue)}
                    backNumberColor={backNumberColor}
                    backNumberStroke={backNumberStroke}
                    backNumberStrokeW={clamp(backNumberStrokeW, 0, 6)}
                    backNumberPosition={[
                      backNumberPosition.x,
                      backNumberPosition.y,
                    ]}
                    backNumberScale={[backNumberScale.x, backNumberScale.y]}
                    backNumberFontSize={backNumberFontSize}
                    backNumberLetterSpacing={backNumberLetterSpacing}
                    
                    shortsFrontNumberValue={shortsFrontNumberValue}
                    showShortsFrontNumber={!!(showShortsFrontNumber && shortsFrontNumberValue)}
                    shortsFrontNumberColor={shortsFrontNumberColor}
                    shortsFrontNumberStroke={shortsFrontNumberStroke}
                    shortsFrontNumberStrokeW={clamp(shortsFrontNumberStrokeW, 0, 6)}
                    shortsFrontNumberPosition={[
                      shortsFrontNumberPosition.x,
                      shortsFrontNumberPosition.y,
                    ]}
                    shortsFrontNumberScale={[
                      shortsFrontNumberScale.x,
                      shortsFrontNumberScale.y,
                    ]}
                    shortsFrontNumberFontSize={shortsFrontNumberFontSize}
                    shortsFrontNumberLetterSpacing={shortsFrontNumberLetterSpacing}
                    
                    shortsBackNumberValue={shortsBackNumberValue}
                    showShortsBackNumber={!!(showShortsBackNumber && shortsBackNumberValue)}
                    shortsBackNumberColor={shortsBackNumberColor}
                    shortsBackNumberStroke={shortsBackNumberStroke}
                    shortsBackNumberStrokeW={clamp(shortsBackNumberStrokeW, 0, 6)}
                    shortsBackNumberPosition={[
                      shortsBackNumberPosition.x,
                      shortsBackNumberPosition.y,
                    ]}
                    shortsBackNumberScale={[shortsBackNumberScale.x, shortsBackNumberScale.y]}
                    shortsBackNumberFontSize={shortsBackNumberFontSize}
                    shortsBackNumberLetterSpacing={shortsBackNumberLetterSpacing}
                    
                    tintFront={tintFront}
                    tintBack={tintBack}
                    tintLArmStripe={tintLArmStripe}
                    tintRArmStripe={tintRArmStripe}
                    tintLShoulderF={tintLShoulderF}
                    tintRShoulderF={tintRShoulderF}
                    tintLShoulderB={tintLShoulderB}
                    tintRShoulderB={tintRShoulderB}
                    tintNeck={tintNeck}
                    tintLSleeve={tintLSleeve}
                    tintRSleeve={tintRSleeve}
                    tintShortsFront={tintShorts}
                    tintShortsBack={tintShorts}
                  />

                  <OrbitControls
                    ref={controlsRef}
                    enableZoom={false}
minDistance={1.5}
maxDistance={3.5}
                    enablePan={false}
                    enableRotate={true}
                    minPolarAngle={Math.PI / 2}
                    maxPolarAngle={Math.PI / 2}
                    autoRotate={autoRotate}
                    autoRotateSpeed={1.2}
                    target={[0, 0, 0]}
                  />
                </Canvas>
              </div>

              <div className="cfg-right">
                <button
                  className="tool"
                  title={autoRotate ? "Pause Rotation" : "Start Rotation"}
                  onClick={() => setAutoRotate(!autoRotate)}
                >
                  {autoRotate ? "⏸️" : "▶️"}
                </button>
                <button
                  className="tool"
                  title="Zoom In"
                  onClick={() =>
                    controlsRef.current?.dolly?.(-0.2) ||
                    (controlsRef.current?.object &&
                      (controlsRef.current.object.position.z -= 0.2))
                  }
                >
                  ＋
                </button>
                <button
                  className="tool"
                  title="Zoom Out"
                  onClick={() =>
                    controlsRef.current?.dolly?.(0.2) ||
                    (controlsRef.current?.object &&
                      (controlsRef.current.object.position.z += 0.2))
                  }
                >
                  －
                </button>
              </div>
            </main>
                        <div className="kit-actions">
  <button
    className="primary-btn"
    onClick={handleProceed}
  >
    Continue to Details
  </button>
</div>
          </div>
        </div>
      </div>

      {/* CSS Styles */}
      <style>{`

  /* ===== PROFESSIONAL PRIMARY CTA ===== */
  .kit-actions {
    margin-top: 0px;
      // padding-top: 12px;  
    display: flex;
    justify-content: left;
  }

  .primary-btn {
    min-width: 260px;
    padding: 14px 28px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.4px;
    border-radius: 12px;
    border: none;
    cursor: pointer;

    color: #ffffff;
    background: linear-gradient(
      135deg,
      #22c55e 0%,
      #16a34a 50%,
      #15803d 100%
    );

    box-shadow:
      0 10px 30px rgba(34, 197, 94, 0.35),
      inset 0 1px 0 rgba(255, 255, 255, 0.25);

    transition: 
      transform 0.2s ease,
      box-shadow 0.2s ease,
      filter 0.2s ease;
  }

  .primary-btn:hover {
    transform: translateY(-2px);
    filter: brightness(1.05);
    box-shadow:
      0 14px 40px rgba(34, 197, 94, 0.45),
      inset 0 1px 0 rgba(255, 255, 255, 0.35);
  }

  .primary-btn:active {
    transform: translateY(0);
    box-shadow:
      0 6px 18px rgba(34, 197, 94, 0.3),
      inset 0 2px 6px rgba(0, 0, 0, 0.25);
  }

  .primary-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
  }






        :root {
          --lexa-w: 240px;
          --lexa-bg: #0f172a;
          --lexa-bg-2: #111827;
          --lexa-accent: #22c55e;
          --lexa-muted: #9ca3af;
          --panel-max: 560px;
        }
        .layout {
          display:flex; min-height:100vh; background:#0b0f1a;
          color:#e5e7eb;
        }
        .lexa-sidebar {
          width:var(--lexa-w);
          background:linear-gradient(180deg,#0f172a 0%, #0b1220 100%);
          border-right:1px solid rgba(255,255,255,0.06);
          position:sticky; top:0; height:100vh; padding:10px 10px 14px; z-index:10;
        }
        .lexa-brand {
          display:flex; align-items:center; gap:10px; padding:10px 8px; border-radius:12px;
          background:linear-gradient(90deg,rgba(34,197,94,0.12),rgba(34,197,94,0.02));
          margin-bottom:10px; position:relative;
        }
        .brand-mark {
          width:34px; height:34px; border-radius:10px; display:grid; place-items:center;
          background:rgba(34,197,94,0.2); color:#a7f3d0; font-weight:700;
        }
        .brand-text { line-height:1.1 }
        .brand-text strong { display:block; font-size:14px; color:#fff }
        .brand-text small { color:#93c5fd; font-size:11px }
        .lexa-hamburger {
          margin-left:auto; background:transparent; border:1px solid rgba(255,255,255,0.12);
          color:#cbd5e1; width:34px; height:34px; border-radius:10px; cursor:pointer;
        }
        .lexa-nav {
          display:flex; flex-direction:column; gap:6px; margin-top:6px;
        }
        .lexa-link {
          display:flex; align-items:center; gap:10px; width:100%;
          padding:10px 12px; color:#cbd5e1; background:transparent; border:1px solid transparent;
          border-radius:10px; cursor:pointer; text-align:left;
        }
        .lexa-link:hover { background:rgba(255,255,255,0.04); }
        .lexa-link.active {
          background:linear-gradient(90deg, rgba(34,197,94,0.16), rgba(34,197,94,0.05));
          color:#eafff3; border-color:rgba(34,197,94,0.25);
        }
        .lexa-icon {
          width:20px; height:20px; display:grid; place-items:center; opacity:.9;
        }
        .lexa-label { font-size:14px; font-weight:600; letter-spacing:.2px; }
        .lexa-main {
          flex:1; display:flex; flex-direction:column; min-width:0;
        }
        .lexa-topbar {
          height:56px; display:flex; align-items:center; justify-content:space-between;
          padding:0 14px; border-bottom:1px solid rgba(255,255,255,0.06);
          background:rgba(17,24,39,0.55); backdrop-filter: blur(10px);
          position:sticky; top:0; z-index:9;
        }
        .top-left { display:flex; align-items:center; gap:10px; }
        .top-title { margin:0; font-size:16px; color:#e5e7eb; }
        .top-hamburger {
          display:none; width:36px; height:36px; border-radius:10px; border:1px solid rgba(255,255,255,0.12);
          background:transparent; color:#cbd5e1; cursor:pointer;
        }
        .top-actions .top-btn {
          background:#111827; border:1px solid rgba(255,255,255,0.12);
          color:#e5e7eb; border-radius:10px; padding:6px 10px; cursor:pointer;
        }
        .cfg-wrap { padding:1px; }
        .cfg-body {
          display:grid; grid-template-columns: minmax(0, var(--panel-max)) 1fr; gap:14px;
        }
        .lexa-panel {
          background:#0c1220; border:1px solid rgba(255,255,255,0.06);
          border-radius:14px; padding:14px;
        }
        .cfg-stage {
          position:relative; background:#0c1220; border:1px solid rgba(255,255,255,0.06);
          border-radius:14px; padding:10px;
        }
        .cfg-right {
          position:absolute; right:10px; top:10px; display:flex; gap:8px;
        }
        .tool {
          width:34px; height:34px; border-radius:10px; border:1px solid rgba(255,255,255,0.12);
          background:#0f172a; color:#e5e7eb; cursor:pointer;
        }
        .designs-head {
          display:flex; gap:8px; margin-bottom:10px;
        }
        .seg {
          padding:8px 12px; border-radius:10px; background:#0f172a; color:#cbd5e1;
          border:1px solid rgba(255,255,255,0.08);
        }
        .seg.active {
          background:#111827; color:#fff; border-color:rgba(34,197,94,0.35);
        }
        .grid-cards {
          display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:10px;
        }
        .card {
          border:1px solid rgba(255,255,255,0.08); border-radius:12px; overflow:hidden;
          background:#0b1120; padding:0;
        }
        .card img {
          width:100%; object-fit:cover; height: 16rem;
        }
        .card.sel {
          outline:2px solid #22c55e; outline-offset:2px;
        }
        .add-product {
          margin-top:10px; width:100%; padding:10px 12px; border-radius:10px;
          background:#111827; color:#e5e7eb; border:1px solid rgba(255,255,255,0.12);
        }
        .color-drawer h4 { margin:0 0 10px 0; }
        .grid2 {
          display:grid; grid-template-columns: 140px 1fr; gap:8px; align-items:center;
        }
        .stage-inner {
          background:#ffffff17; border-radius:8px; position:relative;
          overflow:hidden; width:100%; height:600px;
        }
        .cfg-stage canvas {
          display:block; width:100% !important; height:100% !important; position:relative; zIndex:1;
        }
        .logo-btn {
          padding: 8px 12px;
          background: rgba(34, 197, 94, 0.2);
          border: 1px solid rgba(34, 197, 94, 0.3);
          color: white;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s;
        }
        .logo-btn:hover {
          background: rgba(34, 197, 94, 0.3);
        }
        .logo-btn.danger {
          background: rgba(239, 68, 68, 0.2);
          border: 1px solid rgba(239, 68, 68, 0.3);
        }
        .logo-btn.danger:hover {
          background: rgba(239, 68, 68, 0.3);
        }
        .logo-item:hover {
          background: rgba(255, 255, 255, 0.05) !important;
        }
        .logo-item.selected {
          background: rgba(34, 197, 94, 0.2) !important;
          border-color: rgba(34, 197, 94, 0.5) !important;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

// -------------------- PRELOAD MODEL --------------------
useGLTF.preload("/assets/images/Round_Neck_Goal_Keeper_Kit.glb");